import { LogObject, apiBlockGaRuleParams, apiExampleGenerationCompletedByAiToolParams, apiKeysClickOnActionFromThe3DotsParams, apiKeysClickOnCopyAccountIdParams, apiKeysClickOnGenerateKeyEmptyStateParams, apiKeysClickOnGenerateKeyTopButtonParams, apiKeysClickOnOauthPageLinkParams, apiKeysClickOnSendCodeAgainParams, apiKeysClickOnSendCodeParams, apiKeysClickOnViewApiReferencesParams, apiKeysFinishDeleteKeyParams, apiKeysFinishDuplicateKeyParams, apiKeysFinishEditKeyParams, apiKeysFinishGenerateKeyParams, apiKeysFinishRotateKeyParams, apiKeysStartDeleteKeyParams, apiKeysStartDuplicateKeyParams, apiKeysStartEditKeyParams, apiKeysStartGenerateKeyParams, apiKeysStartRotateKeyParams, appsSettingsDeletionCandidateParams, autoVeloSiteCallForAMethodParams, copyOfHeadlessResumeSetUpDialogClickParams, devCenterWebhookSentTriggeredParams, docsAiAssistantAnswerSrc112Evid14Params, docsAiAssistantClickSrc112Evid13Params, docsAiAssistantCostSrc112Evid1436Params, docsAiAssistantOpenCloseSrc112Evid1435Params, docsRedirectFailureParams, gitToResourceUpdateSrc112Evid30Params, graphqlCallParams, headlessAddWixToYourProjectDialogClickParams, headlessAddWixToYourProjectDialogIsShownParams, headlessDeployThisTemplatePageClickParams, headlessDeployThisTemplatePageIsShownParams, headlessMigrationTourModalShownParams, headlessOAuthInstalledParams, headlessPlaygroundModalFinishedLoadingParams, headlessQuickStartModalShownParams, headlessResumeSetUpDialogIsShownParams, oauthAppClickAtTheCreateEditOauthAppPageParams, oauthAppClickAtTheDeleteOauthAppDialogParams, oauthAppClickAtTheGenerateClientSecretDialogParams, oauthAppClickAtTheOauthAppMainPageParams, oauthAppClickNextCloseAtTheCreateOauthAppDialogParams, oauthAppClickOnCloseFromCreateEditOauthAppPageParams, oauthAppClickOnOauthAppActionParams, oauthAppClickOnSaveFromCreateEditOauthAppPageParams, oauthAppOauthAppActionWasMadeParams, oauthAppOauthAppActionWasMadeServerParams, publicSdkCallParams, relativeLinksFailureParams, settingsAccessParams, spiExternalInvocationSrc96Evid199Params, testSrc184Evid9999Params, testTokenTokenGeneratedServerlessParams, triggerValueWasSelectedParams, webhooksDispatcherResponseChannelTopicSrc155Evid3Params, webhooksInDcCodeExampleWindowClicksParams, webhooksInDcCodeExampleWindowScrollParams, webhooksInDcCreateEventPageClicksParams, webhooksInDcMainPageClicksParams, webhooksInDcTriggeredTestModalClicksParams, wixDocs404PageLoadedParams, wixDocsChooseASearchResultParams, wixDocsClickInPageParams, wixDocsClickOnGiveFeedbackParams, wixDocsClickOnLinksParams, wixDocsClickOnSidebarItemParams, wixDocsClickedOnNavbarParams, wixDocsCloseSearchDialogParams, wixDocsContactOwnerLinkClickedParams, wixDocsCopyCodeParams, wixDocsDocsWasPublishedParams, wixDocsFeedbackSubmittedServerParams, wixDocsFinishLoadingPageParams, wixDocsGiveFeedbackClickParams, wixDocsHoverOnContentTermsParams, wixDocsHoverOverASearchResultItemParams, wixDocsHoverParams, wixDocsMainPageClickParams, wixDocsMainPageScrollParams, wixDocsMenuEditorContentFilterChangeParams, wixDocsMenuEditorEditModeStatusChangeParams, wixDocsMenuEditorInstructionsClicksParams, wixDocsMenuEditorReviewSaveModalClicksParams, wixDocsMenuEditorSideBarActionClickParams, wixDocsMenuEditorSideBarActionFinishedParams, wixDocsMenuEditorSideBarActionMoveToReviewParams, wixDocsMenuEditorSideBarPositionChangedParams, wixDocsMenuEditorVersionsSideBarClicksParams, wixDocsMenuEditorVersionsSideBarLoadedParams, wixDocsModalClickParams, wixDocsModalWasCloseParams, wixDocsModalWasOpenParams, wixDocsNavbarLoadedParams, wixDocsNavigationClickParams, wixDocsObjectShowMembersClickParams, wixDocsOpenCloseExamplesParams, wixDocsPlaygroundLinksDropdownClickParams, wixDocsRedirectByExternalIdSrc112Evid1601Params, wixDocsRelatedSiteClickParams, wixDocsScrollingInSearchResultViewParams, wixDocsSearchOpenedParams, wixDocsSearchResultsParams, wixDocsSendRequestClientParams, wixDocsSendRequestServerParams, wixDocsShareableLinkClickParams, wixDocsSidebarStateParams, wixDocsSiteVisitParams, wixDocsStartLoadingPageParams, wixDocsSubmitFeedbackParams, wixDocsToggleClickParams, wixDocsTryItOutClickParams, wixDocsTypeASearchTermParams, wixDocsViewLiveSiteClickParams, wixDocsViewSourceClickParams, wixDocsVisitLocalViewerParams, wixMcpRequestSrc39Evid1607Params, zapierCustomZapCreatedOrDeletedParams, zapierTestDataClickParams } from '../types';

/**
 * A function to create a log object for the 'wixDocs404PageLoaded' event (evid: 10)
 *
 * Event description: 404 page was loaded
 *
 * @param {wixDocs404PageLoadedParams} params - The parameters for this event
 * @property {string} source - redirect (link) / social / referral (navigation inside the platform )/ organic search (google)
 * @property {string} referral_url - The url of the last page the users have seen, if he open the page by link it will send null
 * @property {string} portal - The current portal
 * @property {boolean} is_first_access - True if this is the first time that the user opened the Wix Docs platform for this session - external nav / internal
 * @property {string} page_url - The url of the current page
 * @property {string} view_mode - Logged in / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {boolean} is_deprecation_error - 404 due to deprecated content without deprecation mode on 
 * @return {LogObject<wixDocs404PageLoadedParams>} LogObject<wixDocs404PageLoadedParams>
 */
export function wixDocs404PageLoaded(params: wixDocs404PageLoadedParams): LogObject<wixDocs404PageLoadedParams> {
  return { evid: 10, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsSendRequestClient' event (evid: 11)
 *
 * Event description: Wix Docs - Send Request (Client)
 *
 * @param {wixDocsSendRequestClientParams} params - The parameters for this event
 * @property {string} body - body type
 * @property {string} customer_id - customer id
 * @property {string} category_name - category name
 * @property {Url} article_url - article_url
 * @property {Url} invoked_url - invoked_url
 * @property {string} http_method - http method type - GET/POST/DELETE/PATCH etc)
 * @property {string} article_name - article name
 * @property {boolean} is_test_token_used - is_test_token_used
 * @return {LogObject<wixDocsSendRequestClientParams>} LogObject<wixDocsSendRequestClientParams>
 */
export function wixDocsSendRequestClient(params: wixDocsSendRequestClientParams): LogObject<wixDocsSendRequestClientParams> {
  return { evid: 11, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsSendRequestServer' event (evid: 111)
 *
 * Event description: Wix Docs - Send Request (server)
 *
 * @param {wixDocsSendRequestServerParams} params - The parameters for this event
 * @property {Url} invoked_url - invoked_url
 * @property {string} http_method - http_method
 * @property {string} response - response
 * @property {boolean} is_success - is_success
 * @return {LogObject<wixDocsSendRequestServerParams>} LogObject<wixDocsSendRequestServerParams>
 */
export function wixDocsSendRequestServer(params: wixDocsSendRequestServerParams): LogObject<wixDocsSendRequestServerParams> {
  return { evid: 111, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsFeedbackSubmittedServer' event (evid: 112)
 *
 * Event description: Wix Docs - Feedback Submitted (Server)
 *
 * @param {wixDocsFeedbackSubmittedServerParams} params - The parameters for this event
 * @property {string} customer_id - customer id
 * @property {Url} article_url - article url
 * @property {string} article_name - article name
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @property {boolean} email_filled - was email filled in by user
 * @return {LogObject<wixDocsFeedbackSubmittedServerParams>} LogObject<wixDocsFeedbackSubmittedServerParams>
 */
export function wixDocsFeedbackSubmittedServer(params: wixDocsFeedbackSubmittedServerParams): LogObject<wixDocsFeedbackSubmittedServerParams> {
  return { evid: 112, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsPlaygroundLinksDropdownClick' event (evid: 12)
 *
 * Event description: Click on Playground Links Dropdown
 *
 * @param {wixDocsPlaygroundLinksDropdownClickParams} params - The parameters for this event
 * @property {string} customer_id - customer_id
 * @property {string} article_url - article url
 * @property {string} article_name - article name
 * @property {boolean} is_main_url_broken - is main url broken
 * @property {string} urls_count - urls count
 * @property {string} selected_url - selected url
 * @return {LogObject<wixDocsPlaygroundLinksDropdownClickParams>} LogObject<wixDocsPlaygroundLinksDropdownClickParams>
 */
export function wixDocsPlaygroundLinksDropdownClick(params: wixDocsPlaygroundLinksDropdownClickParams): LogObject<wixDocsPlaygroundLinksDropdownClickParams> {
  return { evid: 12, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'testTokenTokenGeneratedServerless' event (evid: 1200)
 *
 * Event description: token generated to user's site
 *
 * @param {testTokenTokenGeneratedServerlessParams} params - The parameters for this event
 * @property {string} token - token
 * @property {GUID} selectedMsid - selected_msid
 * @return {LogObject<testTokenTokenGeneratedServerlessParams>} LogObject<testTokenTokenGeneratedServerlessParams>
 */
export function testTokenTokenGeneratedServerless(params: testTokenTokenGeneratedServerlessParams): LogObject<testTokenTokenGeneratedServerlessParams> {
  return { evid: 1200, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'docsAiAssistantClickSrc112Evid13' event (evid: 13)
 *
 * Event description: The event is sent when the Docs AI Assistant was clicked on any button related
 *
 * @param {docsAiAssistantClickSrc112Evid13Params} params - The parameters for this event
 * @property {string} cta - startover, click on the typing box, send-message, copy, feedback-open, feedback-close, feedback-submit, new-conversation, link (copy-code example, link from code not implemented for now)
 * @property {string} portal - The Docs portal
 * @property {string} page_url - The current page url
 * @property {string} session_id - Docs session id
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {string} ai_session_id - ai session id
 * @property {string} extra_values - for example - {feedback answer: yes, feedback content: XXX}
 * @return {LogObject<docsAiAssistantClickSrc112Evid13Params>} LogObject<docsAiAssistantClickSrc112Evid13Params>
 */
export function docsAiAssistantClickSrc112Evid13(params: docsAiAssistantClickSrc112Evid13Params): LogObject<docsAiAssistantClickSrc112Evid13Params> {
  return { evid: 13, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsViewLiveSiteClick' event (evid: 1300)
 *
 * Event description: User clicks on 'View Live Site'
 *
 * @param {wixDocsViewLiveSiteClickParams} params - The parameters for this event
 * @property {string} page - page
 * @return {LogObject<wixDocsViewLiveSiteClickParams>} LogObject<wixDocsViewLiveSiteClickParams>
 */
export function wixDocsViewLiveSiteClick(params: wixDocsViewLiveSiteClickParams): LogObject<wixDocsViewLiveSiteClickParams> {
  return { evid: 1300, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'docsAiAssistantAnswerSrc112Evid14' event (evid: 14)
 *
 * Event description: The event is sent when the Docs AI Assistant is answering the user
 *
 * @param {docsAiAssistantAnswerSrc112Evid14Params} params - The parameters for this event
 * @property {string} portal - The Docs portal
 * @property {string} page_url - The current page url
 * @property {number} response_time - The time it took to the AI to give answer in ms
 * @property {boolean} success - true if the AI gave any answer, if it failed - false
 * @property {string} answer - The AI answer
 * @property {string} question - The user question
 * @property {string} session_id - Docs session id
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {string} ai_session_id - ai session id
 * @return {LogObject<docsAiAssistantAnswerSrc112Evid14Params>} LogObject<docsAiAssistantAnswerSrc112Evid14Params>
 */
export function docsAiAssistantAnswerSrc112Evid14(params: docsAiAssistantAnswerSrc112Evid14Params): LogObject<docsAiAssistantAnswerSrc112Evid14Params> {
  return { evid: 14, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsStartLoadingPage' event (evid: 1400)
 *
 * Event description: Wix Docs page view
 *
 * @param {wixDocsStartLoadingPageParams} params - The parameters for this event
 * @property {string} method - The method of the article, can be empty
 * @property {string} source - redirect (link) / social / referral (navigation inside the platform )/ organic search (google)
 * @property {string} session_id - The current user`s session in the product
 * @property {string} referral_url - The url of the last page the users have seen, if he open the page by link it will send null
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {number} screen_width - Screen width for resolution
 * @property {string} object - The object of the article, can be empty
 * @property {boolean} has_edit_permission - True if the user has edit permission for the current article
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_type - the article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {number} screen_height - Screen height for resolution
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {boolean} is_first_access - True if this is the first time that the user opened the Wix Docs platform for this session
 * @property {string} nav_type - search result click, side bar click, tab click, internal link navigation ,scroll
 * @property {string} page_url - The url of the current page
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {boolean} page_exists - True if the page exists - false if the user landed on resource that is not exists
 * @property {string} deprecation_status - deprecation status of the item/page
 * @return {LogObject<wixDocsStartLoadingPageParams>} LogObject<wixDocsStartLoadingPageParams>
 */
export function wixDocsStartLoadingPage(params: wixDocsStartLoadingPageParams): LogObject<wixDocsStartLoadingPageParams> {
  return { evid: 1400, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsFinishLoadingPage' event (evid: 1401)
 *
 * Event description: Loading time of the first page finished load in Wix Docs.
 *
 * @param {wixDocsFinishLoadingPageParams} params - The parameters for this event
 * @property {string} method - The method of the article, can be empty
 * @property {string} source - redirect (link) / social / referral (navigation inside the platform )/ organic search (google)
 * @property {string} session_id - The current user`s session in the product
 * @property {string} referral_url - The url of the last page the users have seen, if he open the page by link it will send null
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {number} screen_width - Screen width for resolution
 * @property {string} object - The object of the article, can be empty
 * @property {boolean} has_edit_permission - True if the user has edit permission for the current article
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_type - the article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {number} screen_height - Screen height for resolution
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {boolean} is_first_access - True if this is the first time that the user opened the Wix Docs platform for this session
 * @property {string} page_url - The url of the current page
 * @property {number} loading_time - Loading time of page (from evid 112:1400 start loading page)
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {number} TTFB - the TTFB measure of web vitals
 * @property {number} FCP - the FCP measure of web vitals
 * @return {LogObject<wixDocsFinishLoadingPageParams>} LogObject<wixDocsFinishLoadingPageParams>
 */
export function wixDocsFinishLoadingPage(params: wixDocsFinishLoadingPageParams): LogObject<wixDocsFinishLoadingPageParams> {
  return { evid: 1401, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsSearchOpened' event (evid: 1403)
 *
 * Event description: Sends when the search dialog is open, and the user still didnt type a search term
 *
 * @param {wixDocsSearchOpenedParams} params - The parameters for this event
 * @property {boolean} no_connection - True if the search dialog is with a message of no connection
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} recently_viewed - A list of all recently viewed articles that appear in the search dialog, by it`s order
 * @property {string} portal - The current portal
 * @property {string} recent_searches - A list of all recent searches that appear in the search dialog, by it`s order
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {boolean} was_success - True if the dialog was open currectly
 * @property {string} page_url - The url of the current page
 * @property {string} action - The action that the user did to open the search dialog - press the search button \ press "/" at the keyword
 * @return {LogObject<wixDocsSearchOpenedParams>} LogObject<wixDocsSearchOpenedParams>
 */
export function wixDocsSearchOpened(params: wixDocsSearchOpenedParams): LogObject<wixDocsSearchOpenedParams> {
  return { evid: 1403, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsTypeASearchTerm' event (evid: 1404)
 *
 * Event description: When a user is searching in search dialog send event at the end of the results
 *
 * @param {wixDocsTypeASearchTermParams} params - The parameters for this event
 * @property {boolean} no_connection - True if the search dialog is with a message of no connection
 * @property {number} recent_searches_index - The index of the recent\suggested search that was choosen, can be empty
 * @property {string} session_id - The current user`s session in the product
 * @property {string} type_action - The way the user typed the search term - typing \ choosing a recent search \ choosing suggested searches
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {number} num_of_results - The number of total results who return on time
 * @property {string} search_term - The users's search term in the dialog
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {number} total_loading_time - The total time in ms for all results to return
 * @property {string} seen_results - Send only results who were seen in search -> category: article: type: time to load
 * @property {string} page_url - The url of the current page
 * @property {boolean} is_empty - True if the search results is empty from results after finish typing (there was no result found)
 * @property {string} search_results - Send all results who return on time by their order, in the following way -> category: article: type: time to load
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {string} filters - The search box filters - Json
 * @return {LogObject<wixDocsTypeASearchTermParams>} LogObject<wixDocsTypeASearchTermParams>
 */
export function wixDocsTypeASearchTerm(params: wixDocsTypeASearchTermParams): LogObject<wixDocsTypeASearchTermParams> {
  return { evid: 1404, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsScrollingInSearchResultView' event (evid: 1405)
 *
 * Event description: Sends an event when a user scrolls in the search's result
 *
 * @param {wixDocsScrollingInSearchResultViewParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {boolean} is_recently_viewed - True if the search term is empty and the user is hovering over the recently viewed items \ 'what other are searching'
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {number} num_of_results - The number of total results who return on time
 * @property {string} search_term - The users's search term in the dialog, if it is null then the user still didnt wrote a search term but he can scroll in the recently viewed articles
 * @property {boolean} first_search_ever - True if it is the first search of the user ever, and the search dialog contains 'what other are searching' articles
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} page_url - The url of the current page
 * @property {string} search_results - Send all results who return on time by their order, in the following way -> category: article: type: time to load. example: (category: article: type: time to load)
 * [{"category":"Answers","article":"Ab","type":"post","time_to_load_ms":512},{"category":"Business Manager","article":"Cd","type":"get","time_to_load_ms":514]
 * @return {LogObject<wixDocsScrollingInSearchResultViewParams>} LogObject<wixDocsScrollingInSearchResultViewParams>
 */
export function wixDocsScrollingInSearchResultView(params: wixDocsScrollingInSearchResultViewParams): LogObject<wixDocsScrollingInSearchResultViewParams> {
  return { evid: 1405, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsHoverOverASearchResultItem' event (evid: 1406)
 *
 * Event description: When a user is focused on a result
 *
 * @param {wixDocsHoverOverASearchResultItemParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} result_article - The name of the result
 * @property {boolean} is_recently_viewed - True if the search term is empty and the user is hovering over the recently viewed items \ 'what other are searching'
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} search_term - The users's search term in the dialog, if it is null then the user still didnt wrote a search term but he can scroll in the recently viewed articles
 * @property {boolean} first_search_ever - True if it is the first search of the user ever, and the search dialog contains 'what other are searching' articles
 * @property {string} result_category - The category of the result
 * @property {boolean} is_first_hover - True if it is the first item that was hovered
 * @property {string} article_id - The ID of the current article
 * @property {string} result_article_id - The ID of the result article
 * @property {string} article_name - The name of the current article
 * @property {string} page_url - The url of the current page
 * @property {number} item_index - item's index in all results
 * @property {string} search_results - Send all results who return on time by their order, in the following way -> category: article: type: time to load. example: (category: article: type: time to load) [{"category":"Answers","article":"Ab","type":"post","time_to_load_ms":512},{"category":"Business Manager","article":"Cd","type":"get","time_to_load_ms":514]
 * @return {LogObject<wixDocsHoverOverASearchResultItemParams>} LogObject<wixDocsHoverOverASearchResultItemParams>
 */
export function wixDocsHoverOverASearchResultItem(params: wixDocsHoverOverASearchResultItemParams): LogObject<wixDocsHoverOverASearchResultItemParams> {
  return { evid: 1406, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsChooseASearchResult' event (evid: 1407)
 *
 * Event description: Sends an event when a user chose a search result
 *
 * @param {wixDocsChooseASearchResultParams} params - The parameters for this event
 * @property {string} method - The method of the article, can be empty
 * @property {string} chosen_article_type - the chosen article type - get \ webhook \ post \ ..
 * @property {string} session_id - The current user`s session in the product
 * @property {string} chosen_category - The category of the chosen result
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} chosen_article - The name of the chosen result
 * @property {string} choose_type - The way the user chose the result - from an active search \ from the recently viewed options \ from the  'what other are searching' options
 * @property {string} chosen_article_id - The ID of the chosen result article
 * @property {string} object - The object of the article, can be empty
 * @property {string} search_term - The users's search term in the dialog, if it is null then the user still didnt wrote a search term but he can scroll in the recently viewed articles
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {string} chosen_article_url - The url of the chosen result article
 * @property {string} page_url - The url of the current page
 * @property {number} item_index - item's index in all results of the chosen result
 * @property {string} search_results - Send all results who return on time by their order, in the following way -> category: article: type: time to load. example: (category: article: type: time to load) [{"category":"Answers","article":"Ab","type":"post","time_to_load_ms":512},{"category":"Business Manager","article":"Cd","type":"get","time_to_load_ms":514]
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - Deprecation mode is ON
 * @property {string} chosen_portal - The portal of the chosen article
 * @property {string} result_deprecation_status - clicked on deprecated/ about to be deprecated result
 * @return {LogObject<wixDocsChooseASearchResultParams>} LogObject<wixDocsChooseASearchResultParams>
 */
export function wixDocsChooseASearchResult(params: wixDocsChooseASearchResultParams): LogObject<wixDocsChooseASearchResultParams> {
  return { evid: 1407, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsCloseSearchDialog' event (evid: 1408)
 *
 * Event description: Sends an event when a user close the search dialog
 *
 * @param {wixDocsCloseSearchDialogParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} is_search_term_empty - True if the user closed the search dialog while the search box was empty from any term
 * @property {string} search_term - The users's search term in the dialog, if it is null then the user still didnt wrote a search term but he can scroll in the recently viewed articles
 * @property {number} time_in_dialog - Show in ms the time spent in the dialog, from finish typing
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} page_url - The url of the current page
 * @property {string} action - The user`s click for closing the dialog - click on a result/ click somewhere else/ click on x to clear search \ press esc
 * @property {boolean} is_empty - True if the search results is empty from results after finish typing (there was no result found)
 * @property {string} search_results - Send all results who return on time by their order, in the following way -> category: article: type: time to load. example: (category: article: type: time to load) [{"category":"Answers","article":"Ab","type":"post","time_to_load_ms":512},{"category":"Business Manager","article":"Cd","type":"get","time_to_load_ms":514]
 * @return {LogObject<wixDocsCloseSearchDialogParams>} LogObject<wixDocsCloseSearchDialogParams>
 */
export function wixDocsCloseSearchDialog(params: wixDocsCloseSearchDialogParams): LogObject<wixDocsCloseSearchDialogParams> {
  return { evid: 1408, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsSidebarState' event (evid: 1409)
 *
 * Event description: On each page, the event is sent when the side bar is loaded and it also sends the current state of the sidebar - Internal \ Velo \ REST
 *
 * @param {wixDocsSidebarStateParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} referral_url - The url of the last page the users have seen, if he open the page by link it will send null
 * @property {string} category_items_list - List of category items in the main sidebar menu
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} current_sidebar_state - The current state of sidebar - Internal \ Velo \ REST
 * @property {string} article_type - The current article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {boolean} is_first_access - True if this is the first time that the user opened the Wix Docs platform for this session
 * @property {string} page_url - The url of the current page
 * @return {LogObject<wixDocsSidebarStateParams>} LogObject<wixDocsSidebarStateParams>
 */
export function wixDocsSidebarState(params: wixDocsSidebarStateParams): LogObject<wixDocsSidebarStateParams> {
  return { evid: 1409, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsClickOnSidebarItem' event (evid: 1410)
 *
 * Event description: When a user click on sidebar item (to expand drop down \ open an article \ move to other function
 *
 * @param {wixDocsClickOnSidebarItemParams} params - The parameters for this event
 * @property {string} clicked_sidebar_name - The sidebar item the user clicked on (category\article\function)
 * @property {string} clicked_sidebar_article - The sidebar item article the user clicked on, can be empty
 * @property {string} method - The method of the article, can be empty
 * @property {string} current_sidebar_name - The current item name appears in the sidebar - can be changed
 * @property {string} session_id - The current user`s session in the product
 * @property {string} referral_url - The url of the last page the users have seen, if he open the page by link it will send null
 * @property {string} clicked_sidebar_url - The url of the page that the user clicked on
 * @property {string} category_items_list - List of category items in the main sidebar menu
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} current_sidebar_state - The current state of sidebar - Internal \ Velo \ REST
 * @property {string} object - The object of the article, can be empty
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_type - The current article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {string} clicked_sidebar_category - The sidebar item category the user clicked on, can be empty
 * @property {string} page_url - The url of the current page
 * @property {string} action - The action the user did - expand drop down \ open an article \ clicked on category \ move to other function \ back to last sidebar state
 * @return {LogObject<wixDocsClickOnSidebarItemParams>} LogObject<wixDocsClickOnSidebarItemParams>
 */
export function wixDocsClickOnSidebarItem(params: wixDocsClickOnSidebarItemParams): LogObject<wixDocsClickOnSidebarItemParams> {
  return { evid: 1410, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsNavbarLoaded' event (evid: 1411)
 *
 * Event description: The event is sent when the navbar is finish loading
 *
 * @param {wixDocsNavbarLoadedParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} referral_url - The url of the last page the users have seen, if he open the page by link it will send null
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} article_type - The current article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} current_navbar_state - The current state of sidebar - Velo \ REST \ APIs & SDKs \ Wix Docs
 * @property {string} page_url - The url of the current page
 * @return {LogObject<wixDocsNavbarLoadedParams>} LogObject<wixDocsNavbarLoadedParams>
 */
export function wixDocsNavbarLoaded(params: wixDocsNavbarLoadedParams): LogObject<wixDocsNavbarLoadedParams> {
  return { evid: 1411, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsClickedOnNavbar' event (evid: 1412)
 *
 * Event description: The event is sent when the user make any action on the navbar
 *
 * @param {wixDocsClickedOnNavbarParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} referral_url - The url of the last page the users have seen, if he open the page by link it will send null
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} article_type - The current article type - get \ webhook \ post \ ..
 * @property {string} navigate_to - The url that the click navigate to
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} current_navbar_state - The current state of sidebar - Velo \ REST \ APIs & SDKs \ Wix Docs
 * @property {string} page_url - The url of the current page
 * @property {string} action - The action that the user clicked on - APIs & SDKs dropdown \ Wix Docs \ Build a Website\  Build an App \ Velo APIs \ REST APIs \ Client SDK \ sign in \ user dropdown \ light brightness \ dark brightness / log out  / undo / review & save
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsClickedOnNavbarParams>} LogObject<wixDocsClickedOnNavbarParams>
 */
export function wixDocsClickedOnNavbar(params: wixDocsClickedOnNavbarParams): LogObject<wixDocsClickedOnNavbarParams> {
  return { evid: 1412, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsClickOnGiveFeedback' event (evid: 1413)
 *
 * Event description: Sends an event when a user click on a feedback button (yes \ not)
 *
 * @param {wixDocsClickOnGiveFeedbackParams} params - The parameters for this event
 * @property {string} method - The method of the article, can be empty
 * @property {string} session_id - session_id
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} object - The object of the article, can be empty
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_type - The current article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {string} page_url - The url of the current page
 * @property {string} action - The user feedback - yes \ not
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsClickOnGiveFeedbackParams>} LogObject<wixDocsClickOnGiveFeedbackParams>
 */
export function wixDocsClickOnGiveFeedback(params: wixDocsClickOnGiveFeedbackParams): LogObject<wixDocsClickOnGiveFeedbackParams> {
  return { evid: 1413, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsSubmitFeedback' event (evid: 1414)
 *
 * Event description: Sends an event when a user click on submit feedback
 *
 * @param {wixDocsSubmitFeedbackParams} params - The parameters for this event
 * @property {string} method - The method of the article, can be empty
 * @property {string} session_id - The current user`s session in the product
 * @property {string} email - The email that was filled in the feedback
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} object - The object of the article, can be empty
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_type - The current article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} content - The content of the feedback that the user wrote
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {string} page_url - The url of the current page
 * @property {string} action - The user feedback - yes \ not
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {string} feedback_tag - The tag that the user choose
 * @property {boolean} is_logged_in - True if the user was logged in to wix
 * @return {LogObject<wixDocsSubmitFeedbackParams>} LogObject<wixDocsSubmitFeedbackParams>
 */
export function wixDocsSubmitFeedback(params: wixDocsSubmitFeedbackParams): LogObject<wixDocsSubmitFeedbackParams> {
  return { evid: 1414, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsClickInPage' event (evid: 1415)
 *
 * Event description: Sends an event when a user click on any Button: copy link icon \ copy code \ open example \ close example \ in this article navigation click \ view source \ contact owner \ try it out \ syntax REST \ syntax RPC
 *
 * @param {wixDocsClickInPageParams} params - The parameters for this event
 * @property {string} method - The method of the article, can be empty
 * @property {string} function_name - The name of the function that relate to the click, can be empty
 * @property {string} click_name - The name of the link, can be empty
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} object - The object of the article, can be empty
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_type - The current article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} attribute_name - The name of the attribute that relate to the click, can be empty
 * @property {string} click_url - The url of the link, can be empty
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {string} code_type - The code type that was copied - javascript \ js..., can be empty
 * @property {string} page_url - The url of the current page
 * @property {string} action - Click on > in tables \ links \ copy link icon \ copy code \ open example \ close example \ in this article navigation click \ view source \ contact owner \ try it out \ syntax REST \ syntax RPC \ show members \ hide members \ tabs in tables \ click on path navigation header
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsClickInPageParams>} LogObject<wixDocsClickInPageParams>
 */
export function wixDocsClickInPage(params: wixDocsClickInPageParams): LogObject<wixDocsClickInPageParams> {
  return { evid: 1415, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorSideBarActionClick' event (evid: 1416)
 *
 * Event description: The event is sent when a Side bar action click
 *
 * @param {wixDocsMenuEditorSideBarActionClickParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {boolean} is_public - True if the item is already public
 * @property {string} sub_category_name - The sub category name
 * @property {string} item_location - Running number of the item location
 * @property {string} change_id - random number that will present all this action flow (finish, move to review)
 * @property {string} version - The article version, can be null
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} item_type - The item that was clicked from
 * @property {string} page_url - The url of the current page
 * @property {string} action - rename / delete / add category / add sub category / connect resource / unpublish / hide from public / unhide from public / manage resources
 * @return {LogObject<wixDocsMenuEditorSideBarActionClickParams>} LogObject<wixDocsMenuEditorSideBarActionClickParams>
 */
export function wixDocsMenuEditorSideBarActionClick(params: wixDocsMenuEditorSideBarActionClickParams): LogObject<wixDocsMenuEditorSideBarActionClickParams> {
  return { evid: 1416, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorSideBarActionFinished' event (evid: 1417)
 *
 * Event description: The event is sent when a Side bar action finished - approved in the review & save modal
 *
 * @param {wixDocsMenuEditorSideBarActionFinishedParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {boolean} is_public - True if the item is already public
 * @property {string} sub_category_name - The sub category name
 * @property {string} item_location - Running number of the item location
 * @property {string} change_id - random number that will present all this action flow (finish, move to review)
 * @property {string} version - The article version, can be null
 * @property {string} article_id - The ID of the current article
 * @property {string} cta - remove / publish
 * @property {string} article_name - The name of the current article
 * @property {boolean} was_success - True if the action was completed well
 * @property {string} item_type - The item that was clicked from
 * @property {string} md - The md that was connected, will be null unless the action is connect
 * @property {string} page_url - The url of the current page
 * @property {string} action - rename / delete / add category / add sub category / connect resource / unpublish / hide from public / unhide from public / manage resources / item position changed
 * @return {LogObject<wixDocsMenuEditorSideBarActionFinishedParams>} LogObject<wixDocsMenuEditorSideBarActionFinishedParams>
 */
export function wixDocsMenuEditorSideBarActionFinished(params: wixDocsMenuEditorSideBarActionFinishedParams): LogObject<wixDocsMenuEditorSideBarActionFinishedParams> {
  return { evid: 1417, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorSideBarPositionChanged' event (evid: 1418)
 *
 * Event description: The event is sent when a Side bar position changed
 *
 * @param {wixDocsMenuEditorSideBarPositionChangedParams} params - The parameters for this event
 * @property {string} item_location_before - Running number of the item location, before it was moved
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the clicked item, after it was moved
 * @property {string} item_location_after - Running number of the item location, after it was moved
 * @property {string} portal - The current portal
 * @property {boolean} is_public - True if the item is already public
 * @property {string} sub_category_name - The sub category name, after it was moved
 * @property {string} change_id - random number that will present all this action flow (finish, move to review)
 * @property {string} version - The article version, can be null
 * @property {string} article_id - The ID of the current article, after it was moved
 * @property {string} article_name - The name of the current article that was clicked, after it was moved
 * @property {string} item_type - The item that was clicked from
 * @property {string} page_url - The url of the current page
 * @return {LogObject<wixDocsMenuEditorSideBarPositionChangedParams>} LogObject<wixDocsMenuEditorSideBarPositionChangedParams>
 */
export function wixDocsMenuEditorSideBarPositionChanged(params: wixDocsMenuEditorSideBarPositionChangedParams): LogObject<wixDocsMenuEditorSideBarPositionChangedParams> {
  return { evid: 1418, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsDocsWasPublished' event (evid: 1419)
 *
 * Event description: The event is sent when a tech writer is publishing the docs
 *
 * @param {wixDocsDocsWasPublishedParams} params - The parameters for this event
 * @property {string} failure_reason - The reason for the failure, can be empty
 * @property {string} portal - The published area - velo \ rest \ internal
 * @property {string} doc_url - The url of the published doc
 * @property {boolean} was_success - True if the docs were published successfully
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {string} publishedResourceId - The resource id that was published
 * @property {string} fqdn - The fqdn
 * @property {string} namespace - resource name
 * @property {string} publishedRevisionId - The published revision id
 * @return {LogObject<wixDocsDocsWasPublishedParams>} LogObject<wixDocsDocsWasPublishedParams>
 */
export function wixDocsDocsWasPublished(params: wixDocsDocsWasPublishedParams): LogObject<wixDocsDocsWasPublishedParams> {
  return { evid: 1419, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMainPageClick' event (evid: 1420)
 *
 * Event description: The event is sent when the user clicks on any link at the main page of the wix docs
 *
 * @param {wixDocsMainPageClickParams} params - The parameters for this event
 * @property {string} click_name - The name of the link
 * @property {string} portal - portal
 * @property {string} click_url - The url of the clicked link
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsMainPageClickParams>} LogObject<wixDocsMainPageClickParams>
 */
export function wixDocsMainPageClick(params: wixDocsMainPageClickParams): LogObject<wixDocsMainPageClickParams> {
  return { evid: 1420, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMainPageScroll' event (evid: 1421)
 *
 * Event description: The event is sent when the user scrolls the main page of the wix docs
 *
 * @param {wixDocsMainPageScrollParams} params - The parameters for this event
 * @property {string} page_part - what is the part in the page that was exposed
 * @property {string} portal - portal
 * @return {LogObject<wixDocsMainPageScrollParams>} LogObject<wixDocsMainPageScrollParams>
 */
export function wixDocsMainPageScroll(params: wixDocsMainPageScrollParams): LogObject<wixDocsMainPageScrollParams> {
  return { evid: 1421, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsModalWasOpen' event (evid: 1422)
 *
 * Event description: The event is sent when a docs modal was open
 *
 * @param {wixDocsModalWasOpenParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {boolean} has_edit_permission - True if the user has edit permission for the current article
 * @property {string} modal_name - API playground
 * @property {string} article_type - the article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} page_url - The url of the current page
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsModalWasOpenParams>} LogObject<wixDocsModalWasOpenParams>
 */
export function wixDocsModalWasOpen(params: wixDocsModalWasOpenParams): LogObject<wixDocsModalWasOpenParams> {
  return { evid: 1422, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsModalWasClose' event (evid: 1423)
 *
 * Event description: The event is sent when a docs modal was close
 *
 * @param {wixDocsModalWasCloseParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {boolean} has_edit_permission - True if the user has edit permission for the current article
 * @property {string} modal_name - API playground
 * @property {string} article_type - the article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} cta - X / click outside the modal
 * @property {string} article_name - The name of the current article
 * @property {string} page_url - The url of the current page
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsModalWasCloseParams>} LogObject<wixDocsModalWasCloseParams>
 */
export function wixDocsModalWasClose(params: wixDocsModalWasCloseParams): LogObject<wixDocsModalWasCloseParams> {
  return { evid: 1423, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsModalClick' event (evid: 1424)
 *
 * Event description: The event is sent when the user clicks on any cta at a docs modal
 *
 * @param {wixDocsModalClickParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} token_type - Empty / Test Token / Access Token
 * @property {boolean} has_edit_permission - True if the user has edit permission for the current article
 * @property {string} modal_name - API playground
 * @property {string} article_type - the article type - get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} cta - Select Base Url click / Select Base Url change / 
 * Choose a site / Access Token / Generated Test Token type / Access Token type / setting up OAuth link / send request / shareable link
 * @property {string} article_name - The name of the current article
 * @property {boolean} was_success - True if the action successed, relevant only for send request, generate token and generate new token clicks, can be null
 * @property {string} page_url - The url of the current page
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsModalClickParams>} LogObject<wixDocsModalClickParams>
 */
export function wixDocsModalClick(params: wixDocsModalClickParams): LogObject<wixDocsModalClickParams> {
  return { evid: 1424, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorEditModeStatusChange' event (evid: 1425)
 *
 * Event description: The event is sent when a Edit mode status change
 *
 * @param {wixDocsMenuEditorEditModeStatusChangeParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} referral_url - The url of the last page the users have seen, if he open the page by link it will send null
 * @property {string} portal - The current portal
 * @property {string} page_url - The url of the current page
 * @return {LogObject<wixDocsMenuEditorEditModeStatusChangeParams>} LogObject<wixDocsMenuEditorEditModeStatusChangeParams>
 */
export function wixDocsMenuEditorEditModeStatusChange(params: wixDocsMenuEditorEditModeStatusChangeParams): LogObject<wixDocsMenuEditorEditModeStatusChangeParams> {
  return { evid: 1425, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorSideBarActionMoveToReview' event (evid: 1426)
 *
 * Event description: The event is sent when a Side bar action moved to review
 *
 * @param {wixDocsMenuEditorSideBarActionMoveToReviewParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {boolean} is_public - True if the item is already public
 * @property {string} sub_category_name - The sub category name
 * @property {string} item_location - Running number of the item location
 * @property {string} change_id - random number that will present all this action flow (finish, move to review)
 * @property {string} version - The article version, can be null
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {boolean} was_success - True if the action was completed well
 * @property {string} item_type - The item that was clicked from
 * @property {string} md - The md that was connected, will be null unless the action is connect
 * @property {string} page_url - The url of the current page
 * @property {string} action - rename / delete / add category / add sub category / connect resource / unpublish / hide from public / unhide from public / manage resources / item position changed
 * @return {LogObject<wixDocsMenuEditorSideBarActionMoveToReviewParams>} LogObject<wixDocsMenuEditorSideBarActionMoveToReviewParams>
 */
export function wixDocsMenuEditorSideBarActionMoveToReview(params: wixDocsMenuEditorSideBarActionMoveToReviewParams): LogObject<wixDocsMenuEditorSideBarActionMoveToReviewParams> {
  return { evid: 1426, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorVersionsSideBarLoaded' event (evid: 1427)
 *
 * Event description: The event is sent when the versions side bar finish loaded
 *
 * @param {wixDocsMenuEditorVersionsSideBarLoadedParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {boolean} is_public - True if the item is already public
 * @property {string} sub_category_name - The sub category name
 * @property {string} item_location - Running number of the item location
 * @property {string} change_id - random number that will present all this action flow (finish, move to review)
 * @property {string} version - The article version, can be null
 * @property {string} article_id - The ID of the current article
 * @property {string} cta - the cta that opened the sidebar (manage version click / right icon to open)
 * @property {string} article_name - The name of the current article
 * @property {boolean} was_success - True if the action was completed well
 * @property {string} item_type - The item that was clicked from
 * @property {string} page_url - The url of the current page
 * @return {LogObject<wixDocsMenuEditorVersionsSideBarLoadedParams>} LogObject<wixDocsMenuEditorVersionsSideBarLoadedParams>
 */
export function wixDocsMenuEditorVersionsSideBarLoaded(params: wixDocsMenuEditorVersionsSideBarLoadedParams): LogObject<wixDocsMenuEditorVersionsSideBarLoadedParams> {
  return { evid: 1427, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorVersionsSideBarClicks' event (evid: 1428)
 *
 * Event description: The event is sent when the user click on the versions side bar
 *
 * @param {wixDocsMenuEditorVersionsSideBarClicksParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {boolean} is_public - True if the item is already public
 * @property {string} sub_category_name - The sub category name
 * @property {string} item_location - Running number of the item location
 * @property {string} change_id - random number that will present all this action flow (finish, move to review)
 * @property {string} version - The article version, can be null
 * @property {string} article_id - The ID of the current article
 * @property {string} cta - X / add to publish list / remove from publish list / version
 * @property {string} article_name - The name of the current article
 * @property {boolean} was_success - True if the action was completed well
 * @property {string} item_type - The item that was clicked from
 * @property {string} page_url - The url of the current page
 * @property {string} new_version - The clicked version / the version that was chosen to add to publish list / null
 * @return {LogObject<wixDocsMenuEditorVersionsSideBarClicksParams>} LogObject<wixDocsMenuEditorVersionsSideBarClicksParams>
 */
export function wixDocsMenuEditorVersionsSideBarClicks(params: wixDocsMenuEditorVersionsSideBarClicksParams): LogObject<wixDocsMenuEditorVersionsSideBarClicksParams> {
  return { evid: 1428, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorContentFilterChange' event (evid: 1429)
 *
 * Event description: The event is sent when the user change any content filter
 *
 * @param {wixDocsMenuEditorContentFilterChangeParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} portal - The current portal
 * @property {string} cta - beta / ga / internal
 * @property {string} page_url - The url of the current page
 * @property {string} action - show / hide
 * @return {LogObject<wixDocsMenuEditorContentFilterChangeParams>} LogObject<wixDocsMenuEditorContentFilterChangeParams>
 */
export function wixDocsMenuEditorContentFilterChange(params: wixDocsMenuEditorContentFilterChangeParams): LogObject<wixDocsMenuEditorContentFilterChangeParams> {
  return { evid: 1429, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorInstructionsClicks' event (evid: 1430)
 *
 * Event description: The event is sent when the user clicks next at any instruction message
 *
 * @param {wixDocsMenuEditorInstructionsClicksParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} portal - The current portal
 * @property {number} instruction_num - num of instruction
 * @property {string} page_url - The url of the current page
 * @return {LogObject<wixDocsMenuEditorInstructionsClicksParams>} LogObject<wixDocsMenuEditorInstructionsClicksParams>
 */
export function wixDocsMenuEditorInstructionsClicks(params: wixDocsMenuEditorInstructionsClicksParams): LogObject<wixDocsMenuEditorInstructionsClicksParams> {
  return { evid: 1430, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsMenuEditorReviewSaveModalClicks' event (evid: 1431)
 *
 * Event description: The event is sent when the user clicks on any button at the review & save modal
 *
 * @param {wixDocsMenuEditorReviewSaveModalClicksParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} change_ids - a list of all cange_ids that the action was made on
 * @property {string} portal - The current portal
 * @property {string} cta - X / preview all / preview specific change / copy link / cancel / save / remove
 * @property {boolean} was_success - True if the action successed
 * @property {string} page_url - The url of the current page
 * @return {LogObject<wixDocsMenuEditorReviewSaveModalClicksParams>} LogObject<wixDocsMenuEditorReviewSaveModalClicksParams>
 */
export function wixDocsMenuEditorReviewSaveModalClicks(params: wixDocsMenuEditorReviewSaveModalClicksParams): LogObject<wixDocsMenuEditorReviewSaveModalClicksParams> {
  return { evid: 1431, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'relativeLinksFailure' event (evid: 1432)
 *
 * Event description: The event is sent when a relative link was broken
 *
 * @param {relativeLinksFailureParams} params - The parameters for this event
 * @property {string} pageUrl - The url of the current page
 * @property {string} sourceUrl - relative link
 * @property {string} destinationUrl - rendered link
 * @return {LogObject<relativeLinksFailureParams>} LogObject<relativeLinksFailureParams>
 */
export function relativeLinksFailure(params: relativeLinksFailureParams): LogObject<relativeLinksFailureParams> {
  return { evid: 1432, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsClickOnLinks' event (evid: 1433)
 *
 * Event description: Sends an event when a user click on any Link: in this article navigation click \ view source \ contact owner \ try it out \ syntax REST \ syntax RPC
 *
 * @param {wixDocsClickOnLinksParams} params - The parameters for this event
 * @property {string} method - The method of the article, can be empty
 * @property {string} click_name - The name of the link, can be empty
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} object - The object of the article, can be empty
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_type - The current article type - api / md / object / get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} click_url - The url of the link, can be empty
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {string} page_url - The url of the current page
 * @property {string} action - Click on > in tables \ links \ copy link icon \ copy code \ open example \ close example \ in this article navigation click \ view source \ contact owner \ try it out \ syntax REST \ syntax RPC \ show members \ hide members \ tabs in tables \ click on path navigation header
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsClickOnLinksParams>} LogObject<wixDocsClickOnLinksParams>
 */
export function wixDocsClickOnLinks(params: wixDocsClickOnLinksParams): LogObject<wixDocsClickOnLinksParams> {
  return { evid: 1433, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiExampleGenerationCompletedByAiTool' event (evid: 1434)
 *
 * Event description: The event will be sent in any new revision in docs when the example generation is finished per method (successfully or not) and will send the example generation details.
 *
 * @param {apiExampleGenerationCompletedByAiToolParams} params - The parameters for this event
 * @property {string} method - The method name of the example being generated
 * @property {string} namespace - The method namespace
 * @property {string} fqdn - The method fqdn
 * @property {number} numRetries - The number of retries made until the example was generated or failed to generate (limitation of 3)
 * @property {boolean} wasSuccess - True if an example was generated
 * @property {string} portal - REST/ SDK / Velo - where the example was generate to
 * @property {string} failureReasons - A Json of the failure reasons. for example - {retry 1: "reason", retry 2: "reason",.....}
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {string} packageName - The method Package name
 * @property {string} publishedDocRevisionId - the publishedDocRevisionId
 * @return {LogObject<apiExampleGenerationCompletedByAiToolParams>} LogObject<apiExampleGenerationCompletedByAiToolParams>
 */
export function apiExampleGenerationCompletedByAiTool(params: apiExampleGenerationCompletedByAiToolParams): LogObject<apiExampleGenerationCompletedByAiToolParams> {
  return { evid: 1434, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'docsAiAssistantOpenCloseSrc112Evid1435' event (evid: 1435)
 *
 * Event description: The event is sent when the Docs AI Assistant is Opened / Closed
 *
 * @param {docsAiAssistantOpenCloseSrc112Evid1435Params} params - The parameters for this event
 * @property {string} action - open / close
 * @property {string} portal - The Docs portal
 * @property {string} page_url - The current page url
 * @property {number} interaction_time - when the action is close - the time the session took 
 * @property {string} session_id - Docs session id
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {string} ai_session_id - The ai session id
 * @return {LogObject<docsAiAssistantOpenCloseSrc112Evid1435Params>} LogObject<docsAiAssistantOpenCloseSrc112Evid1435Params>
 */
export function docsAiAssistantOpenCloseSrc112Evid1435(params: docsAiAssistantOpenCloseSrc112Evid1435Params): LogObject<docsAiAssistantOpenCloseSrc112Evid1435Params> {
  return { evid: 1435, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'docsAiAssistantCostSrc112Evid1436' event (evid: 1436)
 *
 * Event description: The event is sent when the Docs AI Assistant is sending a response - with the cost it had
 *
 * @param {docsAiAssistantCostSrc112Evid1436Params} params - The parameters for this event
 * @property {string} type - call type
 * @property {number} cost - The cost in dollar
 * @property {number} response_time - in ms
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<docsAiAssistantCostSrc112Evid1436Params>} LogObject<docsAiAssistantCostSrc112Evid1436Params>
 */
export function docsAiAssistantCostSrc112Evid1436(params: docsAiAssistantCostSrc112Evid1436Params): LogObject<docsAiAssistantCostSrc112Evid1436Params> {
  return { evid: 1436, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsHoverOnContentTerms' event (evid: 1437)
 *
 * Event description: Sends an event when a user hovers on wix docs content term, more that 3 sec.
 *
 * @param {wixDocsHoverOnContentTermsParams} params - The parameters for this event
 * @property {string} session_id - The current user`s session in the product
 * @property {string} portal - The current portal
 * @property {string} article_type - The current article type - api / md / object / get \ webhook \ post \ ..
 * @property {string} page_url - The url of the current page
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @return {LogObject<wixDocsHoverOnContentTermsParams>} LogObject<wixDocsHoverOnContentTermsParams>
 */
export function wixDocsHoverOnContentTerms(params: wixDocsHoverOnContentTermsParams): LogObject<wixDocsHoverOnContentTermsParams> {
  return { evid: 1437, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsHover' event (evid: 1438)
 *
 * Event description: Sends an event when a user is hovering over content on Docs
 *
 * @param {wixDocsHoverParams} params - The parameters for this event
 * @property {string} method - The method of the article, can be empty
 * @property {string} hover_name - The name of the content
 * @property {string} session_id - The current user`s session in the product
 * @property {string} category_name - The category of the current article
 * @property {string} portal - The current portal
 * @property {string} object - The object of the article, can be empty
 * @property {string} fqdn - The fqdn of the article, can be empty
 * @property {string} article_type - The current article type - api / md / object / get \ webhook \ post \ ..
 * @property {string} article_id - The ID of the current article
 * @property {string} article_name - The name of the current article
 * @property {string} webhook - The webhook of the article, can be empty
 * @property {string} page_url - The url of the current page
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @property {string} hover_content - The content of the hovered object
 * @return {LogObject<wixDocsHoverParams>} LogObject<wixDocsHoverParams>
 */
export function wixDocsHover(params: wixDocsHoverParams): LogObject<wixDocsHoverParams> {
  return { evid: 1438, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsVisitLocalViewer' event (evid: 15)
 *
 * Event description: User visit the local viewer
 *
 * @param {wixDocsVisitLocalViewerParams} params - The parameters for this event
 * @property {string} local_viewer_id - local_viewer_id
 * @property {string} customer_id - customer id
 * @return {LogObject<wixDocsVisitLocalViewerParams>} LogObject<wixDocsVisitLocalViewerParams>
 */
export function wixDocsVisitLocalViewer(params: wixDocsVisitLocalViewerParams): LogObject<wixDocsVisitLocalViewerParams> {
  return { evid: 15, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsOpenCloseExamples' event (evid: 16)
 *
 * Event description: User open/close examples in wix docs
 *
 * @param {wixDocsOpenCloseExamplesParams} params - The parameters for this event
 * @property {string} customer_id - customer id
 * @property {string} categoryName - category name
 * @property {string} articleUrl - url of article
 * @property {number} exampleId - number of example in the list
 * @property {string} articleName - article name
 * @property {string} action - 'open' or 'close'
 * @return {LogObject<wixDocsOpenCloseExamplesParams>} LogObject<wixDocsOpenCloseExamplesParams>
 */
export function wixDocsOpenCloseExamples(params: wixDocsOpenCloseExamplesParams): LogObject<wixDocsOpenCloseExamplesParams> {
  return { evid: 16, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'docsRedirectFailure' event (evid: 1600)
 *
 * Event description: The event will be sent when there is a docs redirect , and it will send the result
 *
 * @param {docsRedirectFailureParams} params - The parameters for this event
 * @property {string} url - The url
 * @property {boolean} isSuccess - True if the redirect works correct
 * @property {string} view_mode - Logged in  / Internal Mode / Edit Mode / logged out
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<docsRedirectFailureParams>} LogObject<docsRedirectFailureParams>
 */
export function docsRedirectFailure(params: docsRedirectFailureParams): LogObject<docsRedirectFailureParams> {
  return { evid: 1600, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsRedirectByExternalIdSrc112Evid1601' event (evid: 1601)
 *
 * Event description: Wix Docs redirect by external id
 *
 * @param {wixDocsRedirectByExternalIdSrc112Evid1601Params} params - The parameters for this event
 * @property {boolean} is_success - a valid resource was found by the portal and external id data
 * @property {string} redirect_url - the url that was redirect
 * @property {string} external_id - Docs metadata on the resource
 * @property {string} platform - cli/dev center/blocks
 * @property {string} portal_slug - the docs portal
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsRedirectByExternalIdSrc112Evid1601Params>} LogObject<wixDocsRedirectByExternalIdSrc112Evid1601Params>
 */
export function wixDocsRedirectByExternalIdSrc112Evid1601(params: wixDocsRedirectByExternalIdSrc112Evid1601Params): LogObject<wixDocsRedirectByExternalIdSrc112Evid1601Params> {
  return { evid: 1601, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsRelatedSiteClick' event (evid: 17)
 *
 * Event description: Wix Docs - Related Site Click
 *
 * @param {wixDocsRelatedSiteClickParams} params - The parameters for this event
 * @property {string} customer_id - customer_id
 * @property {string} selected_name - selected_name
 * @property {string} selected_url - selected_url
 * @return {LogObject<wixDocsRelatedSiteClickParams>} LogObject<wixDocsRelatedSiteClickParams>
 */
export function wixDocsRelatedSiteClick(params: wixDocsRelatedSiteClickParams): LogObject<wixDocsRelatedSiteClickParams> {
  return { evid: 17, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsViewSourceClick' event (evid: 18)
 *
 * Event description: Wix Docs - View Source Click
 *
 * @param {wixDocsViewSourceClickParams} params - The parameters for this event
 * @property {string} customer_id - customer id
 * @property {string} article_url - article url
 * @property {string} article_name - article name
 * @return {LogObject<wixDocsViewSourceClickParams>} LogObject<wixDocsViewSourceClickParams>
 */
export function wixDocsViewSourceClick(params: wixDocsViewSourceClickParams): LogObject<wixDocsViewSourceClickParams> {
  return { evid: 18, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsObjectShowMembersClick' event (evid: 19)
 *
 * Event description: Click on Show Members
 *
 * @param {wixDocsObjectShowMembersClickParams} params - The parameters for this event
 * @property {string} customer_id - customer_id
 * @property {string} category_name - category name
 * @property {string} article_url - article url
 * @property {string} article_name - article name
 * @property {string} action - action
 * @return {LogObject<wixDocsObjectShowMembersClickParams>} LogObject<wixDocsObjectShowMembersClickParams>
 */
export function wixDocsObjectShowMembersClick(params: wixDocsObjectShowMembersClickParams): LogObject<wixDocsObjectShowMembersClickParams> {
  return { evid: 19, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsSiteVisit' event (evid: 2)
 *
 * Event description: Visit to Wix Docs page
 *
 * @param {wixDocsSiteVisitParams} params - The parameters for this event
 * @property {string} customer_id - customer id of our business client (app_builder, dev center,
 * @property {Url} referral_url - referral_url
 * @property {string} category_name - category
 * @property {number} screen_width - screen_width
 * @property {number} screen_height - screen height
 * @property {string} article_name - article name
 * @property {Url} page_url - page url of customer
 * @return {LogObject<wixDocsSiteVisitParams>} LogObject<wixDocsSiteVisitParams>
 */
export function wixDocsSiteVisit(params: wixDocsSiteVisitParams): LogObject<wixDocsSiteVisitParams> {
  return { evid: 2, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsToggleClick' event (evid: 22)
 *
 * Event description: Click on a toggle to change View mode/Deprecation mode/Edit mode...
 *
 * @param {wixDocsToggleClickParams} params - The parameters for this event
 * @property {string} toggle_name - the name of the toggle that was clicked
 * @property {string} toggle_status - the current status of the toggle (before clicking)
 * @property {string} page_url - the url of the current page (when clicking on the toggle)
 * @property {string} article_name - the name of the current item
 * @property {boolean} is_deprecation_mode - deprecation mode is on
 * @return {LogObject<wixDocsToggleClickParams>} LogObject<wixDocsToggleClickParams>
 */
export function wixDocsToggleClick(params: wixDocsToggleClickParams): LogObject<wixDocsToggleClickParams> {
  return { evid: 22, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsGiveFeedbackClick' event (evid: 3)
 *
 * Event description: User clicks on "yes" or "no" feedback click for articles.
 *
 * @param {wixDocsGiveFeedbackClickParams} params - The parameters for this event
 * @property {string} customer_id - customer_id
 * @property {Url} article_url - article_url
 * @property {string} article_name - article_name
 * @property {boolean} positive_feedback - feedback given, Yes or No - for helpful
 * @return {LogObject<wixDocsGiveFeedbackClickParams>} LogObject<wixDocsGiveFeedbackClickParams>
 */
export function wixDocsGiveFeedbackClick(params: wixDocsGiveFeedbackClickParams): LogObject<wixDocsGiveFeedbackClickParams> {
  return { evid: 3, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'gitToResourceUpdateSrc112Evid30' event (evid: 30)
 *
 * Event description: Tracking git to resource update pipline
 *
 * @param {gitToResourceUpdateSrc112Evid30Params} params - The parameters for this event
 * @property {string} flow - the consumed/produced event topic (REST/SDK/MD)
 * @property {string} step - the name of the step
 * @property {string} revision_id_1 - revision id
 * @property {string} resource_id_1 - resource id
 * @property {string} entity_id - fqdn (for open api resolver) 
 * @property {string} repository_full_name - repository name (for md resolver and repo whitlist in autogen)
 * @property {string} package_name - package name (for public sdk and auto velo)
 * @property {string} module_name - module name (for legacy velo)
 * @property {string} git_commit_hash - unique identifier of the current pipeline. consistent over the pipeline
 * @return {LogObject<gitToResourceUpdateSrc112Evid30Params>} LogObject<gitToResourceUpdateSrc112Evid30Params>
 */
export function gitToResourceUpdateSrc112Evid30(params: gitToResourceUpdateSrc112Evid30Params): LogObject<gitToResourceUpdateSrc112Evid30Params> {
  return { evid: 30, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsSearchResults' event (evid: 4)
 *
 * Event description: Search results returned (search action performed)
 *
 * @param {wixDocsSearchResultsParams} params - The parameters for this event
 * @property {string} chosen_article_name - Chosen article name
 * @property {string} user_action - action taken by user = [exit_search, result_click, clear_button]
 * @property {string} customer_id - customer id of our business client (app_builder, dev center,
 * @property {Url} first_article_url - url of first url returned in search
 * @property {string} first_article_category - the category of the the first search result
 * @property {Url} chosen_article - the url of the article that the user clicked, if clicked
 * @property {string} first_article_name - the first name of the article
 * @property {number} num_of_results - how many articles were found for the search?
 * @property {string} search_term - search term used in search action
 * @property {string} chosen_category_name - name of chosen category
 * @property {Url} chosen_article_url - chosen article url
 * @return {LogObject<wixDocsSearchResultsParams>} LogObject<wixDocsSearchResultsParams>
 */
export function wixDocsSearchResults(params: wixDocsSearchResultsParams): LogObject<wixDocsSearchResultsParams> {
  return { evid: 4, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsNavigationClick' event (evid: 5)
 *
 * Event description: Menu navigation click
 *
 * @param {wixDocsNavigationClickParams} params - The parameters for this event
 * @property {string} customer_id - customer id of our business client (app_builder, dev center,
 * @property {string} category_name - name of category in menu
 * @property {Url} article_url - article url
 * @property {string} article_name - name of article inside of category
 * @property {string} nav_type - breadcrumb, category, article, scroll (after 5 secs)
 * @return {LogObject<wixDocsNavigationClickParams>} LogObject<wixDocsNavigationClickParams>
 */
export function wixDocsNavigationClick(params: wixDocsNavigationClickParams): LogObject<wixDocsNavigationClickParams> {
  return { evid: 5, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsContactOwnerLinkClicked' event (evid: 6)
 *
 * Event description: Link to contact owner clicked
 *
 * @param {wixDocsContactOwnerLinkClickedParams} params - The parameters for this event
 * @property {string} customer_id - customer id
 * @property {string} article_url - article url
 * @property {string} article_name - article name
 * @property {string} link_type - link type clicked
 * @return {LogObject<wixDocsContactOwnerLinkClickedParams>} LogObject<wixDocsContactOwnerLinkClickedParams>
 */
export function wixDocsContactOwnerLinkClicked(params: wixDocsContactOwnerLinkClickedParams): LogObject<wixDocsContactOwnerLinkClickedParams> {
  return { evid: 6, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsCopyCode' event (evid: 7)
 *
 * Event description: Copy the code given in the article example
 *
 * @param {wixDocsCopyCodeParams} params - The parameters for this event
 * @property {string} customer_id - customer id of our business client (app_builder, dev center,
 * @property {string} category_name - name of category
 * @property {Url} article_url - the url of the article that was copied
 * @property {string} id - id of copied data
 * @property {string} article_name - name of article
 * @return {LogObject<wixDocsCopyCodeParams>} LogObject<wixDocsCopyCodeParams>
 */
export function wixDocsCopyCode(params: wixDocsCopyCodeParams): LogObject<wixDocsCopyCodeParams> {
  return { evid: 7, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsTryItOutClick' event (evid: 8)
 *
 * Event description: Wix Docs - Try it Out - Click
 *
 * @param {wixDocsTryItOutClickParams} params - The parameters for this event
 * @property {string} customer_id - customer id
 * @property {string} category_name - category name
 * @property {Url} article_url - article_url
 * @property {string} article_name - article name
 * @return {LogObject<wixDocsTryItOutClickParams>} LogObject<wixDocsTryItOutClickParams>
 */
export function wixDocsTryItOutClick(params: wixDocsTryItOutClickParams): LogObject<wixDocsTryItOutClickParams> {
  return { evid: 8, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixDocsShareableLinkClick' event (evid: 9)
 *
 * Event description: Wix Docs - Shareable Link - Click
 *
 * @param {wixDocsShareableLinkClickParams} params - The parameters for this event
 * @property {string} customer_id - customer id
 * @property {string} category_name - category name
 * @property {Url} article_url - article_url
 * @property {string} article_name - article name
 * @return {LogObject<wixDocsShareableLinkClickParams>} LogObject<wixDocsShareableLinkClickParams>
 */
export function wixDocsShareableLinkClick(params: wixDocsShareableLinkClickParams): LogObject<wixDocsShareableLinkClickParams> {
  return { evid: 9, src: 112, endpoint: '', params };
}

/**
 * A function to create a log object for the 'publicSdkCall' event (evid: 1606)
 *
 * Event description: The event is sent when there is a call for an API
 *
 * @param {publicSdkCallParams} params - The parameters for this event
 * @property {string} http_code - status response : 200 / 401 / 403 / 404 / 500
 * @property {Url} url - The url of the destination of the call (URL/URI)
 * @property {number} latency - The API latency
 * @property {string} auth_type - API Keys / OAuth app / ..
 * @property {string} app_def_id - The app_def_id of the caller
 * @property {string} package_version - bi-package-version
 * @property {string} http_method - REST protocol (Post / delete / patch / put / delete)
 * @property {string} entity_name - The name of the entity that was called (fqdn)
 * @property {string} package_name - bi-package-name
 * @property {string} origin_url - The url that the call was from
 * @property {string} environment - js-sdk (sdk before we changed the field) / velo-frontend (auto velo) / velo-backend (auto velo) / vanilla (rest) / js-dashboard / js-api_key / js-velo-backend / js-velo-frontend / js-app (TPA using sdk - for example cli apps) /  js-site /  js-editor
 * @property {string} method_name - The name of the method that was called (fqn)
 * @property {string} msid - The ID of the site
 * @property {string} mcp_tool_execution_id - wix mcp server tool execution id
 * @property {string} entity_name_fw - entity_name_fw
 * @property {string} method_name_fw - method_name_fw
 * @property {GUID} instance_id - The instance id - msid+app_id
 * @property {string} integration_type - Wix / TPA (headless, api keys, blocks) / Velo
 * @return {LogObject<publicSdkCallParams>} LogObject<publicSdkCallParams>
 */
export function publicSdkCall(params: publicSdkCallParams): LogObject<publicSdkCallParams> {
  return { evid: 1606, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessQuickStartModalShown' event (evid: 11)
 *
 * Event description: The Headless quick-start modal shown - will be sent in any step of the modal
 *
 * @param {headlessQuickStartModalShownParams} params - The parameters for this event
 * @property {string} step - create an OAuth app / install SDK / call our API
 * @property {string} technology - javascript / react/ / others / null if it wasnt chosen yet
 * @property {string} appType - web / mobile / other / null if it wasn't chosen yet
 * @property {string} entryPoint - where the modal opened from - focus widget / create oauth from settings
 * @property {boolean} isNewFlow - True if new 
 * @return {LogObject<headlessQuickStartModalShownParams>} LogObject<headlessQuickStartModalShownParams>
 */
export function headlessQuickStartModalShown(params: headlessQuickStartModalShownParams): LogObject<headlessQuickStartModalShownParams> {
  return { evid: 11, src: 151, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessPlaygroundModalFinishedLoading' event (evid: 12)
 *
 * Event description: The event will be sent when the user clicks on any button of the modal
 *
 * @param {headlessPlaygroundModalFinishedLoadingParams} params - The parameters for this event
 * @property {string} step - create an OAuth app / install SDK / call our API
 * @property {string} cta - learn more, create&cont, tech, copy code, any wix api tool link, go to settings, close, app_type (the type will be sent in "value" field)
 * X, etc
 *
 * @property {string} value - name, app type, copy code type, etc (can be null)
 * @property {string} technology -  javascript / react/ / others / null if it wasnt chosen yet
 *
 * @property {string} appType - web / mobile / other / null if it wasnt chosen yet
 *
 * @property {string} entryPoint - where the modal opened from - focus widget / create oauth from settings
 *
 * @return {LogObject<headlessPlaygroundModalFinishedLoadingParams>} LogObject<headlessPlaygroundModalFinishedLoadingParams>
 */
export function headlessPlaygroundModalFinishedLoading(params: headlessPlaygroundModalFinishedLoadingParams): LogObject<headlessPlaygroundModalFinishedLoadingParams> {
  return { evid: 12, src: 151, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppClickOnOauthAppAction' event (evid: 100)
 *
 * Event description: The event is sent when the user click to create/delete/edit OAuth app
 *
 * @param {oauthAppClickOnOauthAppActionParams} params - The parameters for this event
 * @property {string} app_description - The app description, can be empty
 * @property {string} allowed_domains - The app allowed domains, can be empty
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} app_name - The app name, can be empty
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} login_urls - List of the login URLs, can be empty
 * @property {string} app_id - The id of the app, can be empty
 * @property {string} msid - The msid of the site
 * @property {string} action - create / create from empty state / edit / delete
 * @return {LogObject<oauthAppClickOnOauthAppActionParams>} LogObject<oauthAppClickOnOauthAppActionParams>
 */
export function oauthAppClickOnOauthAppAction(params: oauthAppClickOnOauthAppActionParams): LogObject<oauthAppClickOnOauthAppActionParams> {
  return { evid: 100, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppClickAtTheOauthAppMainPage' event (evid: 101)
 *
 * Event description: The event is sent when the user clicks on any action from the OAuth app main page, other than apps actions (copy account ID button, referral link)
 *
 * @param {oauthAppClickAtTheOauthAppMainPageParams} params - The parameters for this event
 * @property {string} url_clicked - The URL that the user opened by a click on the link, can be empty
 * @property {string} field_value - The redirect URL, can be null
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} cta - copy account id button / referral link / edit domain
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} msid - The msid of the site
 * @return {LogObject<oauthAppClickAtTheOauthAppMainPageParams>} LogObject<oauthAppClickAtTheOauthAppMainPageParams>
 */
export function oauthAppClickAtTheOauthAppMainPage(params: oauthAppClickAtTheOauthAppMainPageParams): LogObject<oauthAppClickAtTheOauthAppMainPageParams> {
  return { evid: 101, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppClickNextCloseAtTheCreateOauthAppDialog' event (evid: 102)
 *
 * Event description: The event is sent when the user click on next button at the Create a OAuth app dialog
 *
 * @param {oauthAppClickNextCloseAtTheCreateOauthAppDialogParams} params - The parameters for this event
 * @property {string} app_description - The app description, can be empty
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} app_name - The app name
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} app_id - The id of the app, can be empty
 * @property {string} msid - The msid of the site
 * @property {string} action - next / close
 * @return {LogObject<oauthAppClickNextCloseAtTheCreateOauthAppDialogParams>} LogObject<oauthAppClickNextCloseAtTheCreateOauthAppDialogParams>
 */
export function oauthAppClickNextCloseAtTheCreateOauthAppDialog(params: oauthAppClickNextCloseAtTheCreateOauthAppDialogParams): LogObject<oauthAppClickNextCloseAtTheCreateOauthAppDialogParams> {
  return { evid: 102, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppClickAtTheCreateEditOauthAppPage' event (evid: 103)
 *
 * Event description: The event is sent when the user click on any action from the edit / create OAuth app page, other then close / save (copy account ID button, refferal link, show client secret, hide client secret, rotate client secret, add redirect URL)
 *
 * @param {oauthAppClickAtTheCreateEditOauthAppPageParams} params - The parameters for this event
 * @property {string} url_clicked - The URL that the user opend by a click on the link, can be empty
 * @property {string} app_description - The app description, can be empty
 * @property {string} app_action - create / edit
 * @property {string} allowed_domains - The app allowed domains, can be empty
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} cta - copy account ID button, refferal link, show client secret, hide client secret, rotate client secret, add redirect URL
 * @property {string} app_name - The app name
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} login_urls - List of the login URLs, can be empty
 * @property {string} app_id - The id of the app, can be empty
 * @property {string} allowed_authorize_urls - The app allowed_authorize_urls, can be empty
 * @property {string} msid - The msid of the site
 * @return {LogObject<oauthAppClickAtTheCreateEditOauthAppPageParams>} LogObject<oauthAppClickAtTheCreateEditOauthAppPageParams>
 */
export function oauthAppClickAtTheCreateEditOauthAppPage(params: oauthAppClickAtTheCreateEditOauthAppPageParams): LogObject<oauthAppClickAtTheCreateEditOauthAppPageParams> {
  return { evid: 103, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppClickOnCloseFromCreateEditOauthAppPage' event (evid: 104)
 *
 * Event description: The event is sent when the user clicks on close from edit OAuth app page (didnt save changes \ didnt create an app)
 *
 * @param {oauthAppClickOnCloseFromCreateEditOauthAppPageParams} params - The parameters for this event
 * @property {string} app_action - create / edit
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} app_name - The app name
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} app_id - The id of the app, can be empty
 * @property {string} msid - The msid of the site
 * @return {LogObject<oauthAppClickOnCloseFromCreateEditOauthAppPageParams>} LogObject<oauthAppClickOnCloseFromCreateEditOauthAppPageParams>
 */
export function oauthAppClickOnCloseFromCreateEditOauthAppPage(params: oauthAppClickOnCloseFromCreateEditOauthAppPageParams): LogObject<oauthAppClickOnCloseFromCreateEditOauthAppPageParams> {
  return { evid: 104, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppClickOnSaveFromCreateEditOauthAppPage' event (evid: 105)
 *
 * Event description: The event is sent when the user clicks on save from edit OAuth app page (create an app \ save changes of an app)
 *
 * @param {oauthAppClickOnSaveFromCreateEditOauthAppPageParams} params - The parameters for this event
 * @property {string} old_login_urls - List of the old login URLs, can be empty if there were no changes
 * @property {string} app_description - The current app description
 * @property {string} app_action - create / edit
 * @property {string} old_allowed_domains - The old app allowed domains, can be empty if there were no changes
 * @property {string} old_app_name - The old app name, can be empty if there were no changes
 * @property {string} allowed_domains - The current app allowed domains
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} app_name - The current app name
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} login_urls - The current list of the login URLs
 * @property {string} app_id - The current id of the app
 * @property {string} allowed_authorize_urls - The app allowed_authorize_urls, can be empty
 * @property {string} old_app_description - The old app description, can be empty if there were no changes
 * @property {string} msid - The msid of the site
 * @return {LogObject<oauthAppClickOnSaveFromCreateEditOauthAppPageParams>} LogObject<oauthAppClickOnSaveFromCreateEditOauthAppPageParams>
 */
export function oauthAppClickOnSaveFromCreateEditOauthAppPage(params: oauthAppClickOnSaveFromCreateEditOauthAppPageParams): LogObject<oauthAppClickOnSaveFromCreateEditOauthAppPageParams> {
  return { evid: 105, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppClickAtTheDeleteOauthAppDialog' event (evid: 106)
 *
 * Event description: The event is sent when the user slick on some button at the delete app dialog - (delete \ send code \ send code again \ verify and delete an app)
 *
 * @param {oauthAppClickAtTheDeleteOauthAppDialogParams} params - The parameters for this event
 * @property {string} app_description - The app description
 * @property {string} allowed_domains - The app allowed domains
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} app_name - The app name
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} login_urls - List of the login URLs
 * @property {string} app_id - The id of the app
 * @property {string} msid - The msid of the site
 * @property {string} action - delete / send code / send code again / verify and delete an app
 * @return {LogObject<oauthAppClickAtTheDeleteOauthAppDialogParams>} LogObject<oauthAppClickAtTheDeleteOauthAppDialogParams>
 */
export function oauthAppClickAtTheDeleteOauthAppDialog(params: oauthAppClickAtTheDeleteOauthAppDialogParams): LogObject<oauthAppClickAtTheDeleteOauthAppDialogParams> {
  return { evid: 106, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppOauthAppActionWasMade' event (evid: 107)
 *
 * Event description: The event is sent when an OAuth app was created / deleted / edited
 *
 * @param {oauthAppOauthAppActionWasMadeParams} params - The parameters for this event
 * @property {string} old_login_urls - List of the old login URLs, can be empty if there were no changes
 * @property {string} failure_reason - The failure reason, can be empty
 * @property {string} app_description - The current app description
 * @property {string} app_action - create / edit / delete
 * @property {string} old_allowed_domains - The old app allowed domains, can be empty if there were no changes
 * @property {string} old_app_name - The old app name, can be empty if there were no changes
 * @property {string} allowed_domains - The current app allowed domains
 * @property {string} old_allowed_authorize_urls - The old app allowed_authorize_urls, can be empty
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} app_name - The current app name
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} login_urls - The current list of the login URLs
 * @property {string} app_id - The current id of the app
 * @property {string} allowed_authorize_urls - The app allowed_authorize_urls, can be empty
 * @property {boolean} was_success - True if the action was finished successfully
 * @property {number} time_to_finish - The time it took to finish the action in ms
 * @property {string} old_app_description - The old app description, can be empty if there were no changes
 * @property {string} msid - The msid of the site
 * @property {boolean} is_new_flow - True is it was created by the new flow
 * @return {LogObject<oauthAppOauthAppActionWasMadeParams>} LogObject<oauthAppOauthAppActionWasMadeParams>
 */
export function oauthAppOauthAppActionWasMade(params: oauthAppOauthAppActionWasMadeParams): LogObject<oauthAppOauthAppActionWasMadeParams> {
  return { evid: 107, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppClickAtTheGenerateClientSecretDialog' event (evid: 108)
 *
 * Event description: The event is sent when the user click at the generate client secret dialog
 *
 * @param {oauthAppClickAtTheGenerateClientSecretDialogParams} params - The parameters for this event
 * @property {string} app_description - The app description
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} app_name - The app name
 * @property {string} app_id - The id of the app
 * @property {string} msid - The msid of the site
 * @property {string} action - Copy & close / copy icon / learn more link
 * @return {LogObject<oauthAppClickAtTheGenerateClientSecretDialogParams>} LogObject<oauthAppClickAtTheGenerateClientSecretDialogParams>
 */
export function oauthAppClickAtTheGenerateClientSecretDialog(params: oauthAppClickAtTheGenerateClientSecretDialogParams): LogObject<oauthAppClickAtTheGenerateClientSecretDialogParams> {
  return { evid: 108, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oauthAppOauthAppActionWasMadeServer' event (evid: 151)
 *
 * Event description: The event is sent when an OAuth app was created / deleted / edited, server event
 *
 * @param {oauthAppOauthAppActionWasMadeServerParams} params - The parameters for this event
 * @property {string} old_login_urls - List of the old login URLs, can be empty if there were no changes
 * @property {string} failure_reason - The failure reason, can be empty
 * @property {string} app_description - The current app description
 * @property {string} app_action - create / edit / delete
 * @property {string} old_allowed_domains - The old app allowed domains, can be empty if there were no changes
 * @property {string} old_app_name - The old app name, can be empty if there were no changes
 * @property {string} allowed_domains - The current app allowed domains
 * @property {string} old_allowed_authorize_urls - The old app allowed_authorize_urls, can be empty
 * @property {string} account_id - The ID of the account that the site owned by
 * @property {string} app_name - The current app name
 * @property {number} num_apps - The number of Apps that already exists for this site
 * @property {string} login_urls - The current list of the login URLs
 * @property {string} app_id - The current id of the app
 * @property {string} allowed_authorize_urls - The app allowed_authorize_urls, can be empty
 * @property {boolean} was_success - True if the action was finished successfully
 * @property {number} time_to_finish - time_to_finish
 * @property {string} old_app_description - The old app description, can be empty if there were no changes
 * @property {string} msid - The msid of the site
 * @property {string} action_initiator - the initiator of the action (user/developer/picasso)
 * @return {LogObject<oauthAppOauthAppActionWasMadeServerParams>} LogObject<oauthAppOauthAppActionWasMadeServerParams>
 */
export function oauthAppOauthAppActionWasMadeServer(params: oauthAppOauthAppActionWasMadeServerParams): LogObject<oauthAppOauthAppActionWasMadeServerParams> {
  return { evid: 151, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysStartGenerateKey' event (evid: 202)
 *
 * Event description: The event is sent when the user click on verify & generate key, to start generate key
 *
 * @param {apiKeysStartGenerateKeyParams} params - The parameters for this event
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysStartGenerateKeyParams>} LogObject<apiKeysStartGenerateKeyParams>
 */
export function apiKeysStartGenerateKey(params: apiKeysStartGenerateKeyParams): LogObject<apiKeysStartGenerateKeyParams> {
  return { evid: 202, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysFinishGenerateKey' event (evid: 203)
 *
 * Event description: The event is sent when a key is finish the generating process, regardless it was a success or not
 *
 * @param {apiKeysFinishGenerateKeyParams} params - The parameters for this event
 * @property {string} failure_reason - The reason for the failure, can be empty
 * @property {string} app_def_id - the app_def_id of the key
 * @property {string} key_id - The current app ID
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {number} time_to_generate - The time it took to generate the key in ms (from evid 202 start generate key)
 * @property {boolean} was_success - True if the key was generate successfully
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysFinishGenerateKeyParams>} LogObject<apiKeysFinishGenerateKeyParams>
 */
export function apiKeysFinishGenerateKey(params: apiKeysFinishGenerateKeyParams): LogObject<apiKeysFinishGenerateKeyParams> {
  return { evid: 203, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysClickOnActionFromThe3Dots' event (evid: 204)
 *
 * Event description: The event is sent when the user clicks on the top button 'generate api key'
 *
 * @param {apiKeysClickOnActionFromThe3DotsParams} params - The parameters for this event
 * @property {string} key_id - The current app ID
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {string} action - The action the user press on - edit \ duplicate \ rotate \ delete
 * @return {LogObject<apiKeysClickOnActionFromThe3DotsParams>} LogObject<apiKeysClickOnActionFromThe3DotsParams>
 */
export function apiKeysClickOnActionFromThe3Dots(params: apiKeysClickOnActionFromThe3DotsParams): LogObject<apiKeysClickOnActionFromThe3DotsParams> {
  return { evid: 204, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysClickOnGenerateKeyTopButton' event (evid: 205)
 *
 * Event description: The event is sent when the user clicks on the 'generate API key' top button on the main page
 *
 * @param {apiKeysClickOnGenerateKeyTopButtonParams} params - The parameters for this event
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysClickOnGenerateKeyTopButtonParams>} LogObject<apiKeysClickOnGenerateKeyTopButtonParams>
 */
export function apiKeysClickOnGenerateKeyTopButton(params: apiKeysClickOnGenerateKeyTopButtonParams): LogObject<apiKeysClickOnGenerateKeyTopButtonParams> {
  return { evid: 205, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysClickOnGenerateKeyEmptyState' event (evid: 206)
 *
 * Event description: The event is sent when the user clicks on the '+ generate key' when he has an empty state - while the user has 0 keys
 *
 * @param {apiKeysClickOnGenerateKeyEmptyStateParams} params - The parameters for this event
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysClickOnGenerateKeyEmptyStateParams>} LogObject<apiKeysClickOnGenerateKeyEmptyStateParams>
 */
export function apiKeysClickOnGenerateKeyEmptyState(params: apiKeysClickOnGenerateKeyEmptyStateParams): LogObject<apiKeysClickOnGenerateKeyEmptyStateParams> {
  return { evid: 206, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysClickOnViewApiReferences' event (evid: 207)
 *
 * Event description: The event is sent when the user clicks one of the 'view preference options.
 * main page top button, main page API button, main page top learn how to link, key page permissions links, key page learn more, key page top learn how to link, learn more - generate key completed window, learn more - rotate key request window, learn more - rotate key completed window
 *
 * @param {apiKeysClickOnViewApiReferencesParams} params - The parameters for this event
 * @property {string} button_type - Click on one of the API references button - main page top button, main page API button, main page top learn how to link, key page permissions links, key page learn more, key page top learn how to link, learn more - generate key completed window, learn more - rotate key request window, learn more - rotate key completed window
 * @property {string} page_name - The current page name - main page \ key page
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysClickOnViewApiReferencesParams>} LogObject<apiKeysClickOnViewApiReferencesParams>
 */
export function apiKeysClickOnViewApiReferences(params: apiKeysClickOnViewApiReferencesParams): LogObject<apiKeysClickOnViewApiReferencesParams> {
  return { evid: 207, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysClickOnCopyAccountId' event (evid: 208)
 *
 * Event description: The event is sent when the user clicks on the copy account ID button
 *
 * @param {apiKeysClickOnCopyAccountIdParams} params - The parameters for this event
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysClickOnCopyAccountIdParams>} LogObject<apiKeysClickOnCopyAccountIdParams>
 */
export function apiKeysClickOnCopyAccountId(params: apiKeysClickOnCopyAccountIdParams): LogObject<apiKeysClickOnCopyAccountIdParams> {
  return { evid: 208, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysStartEditKey' event (evid: 209)
 *
 * Event description: The event is sent when the user clicks on verify & save changes, to start editing a key
 *
 * @param {apiKeysStartEditKeyParams} params - The parameters for this event
 * @property {string} old_key_permissions - The old permissions for the key
 * @property {string} new_key_name - The new api key name
 * @property {string} change_taken - The type of change taken - name\permisions\null
 * @property {string} key_id - The current app ID
 * @property {string} old_key_name - The old api name
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} new_key_permissions - The new permissions for the key
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysStartEditKeyParams>} LogObject<apiKeysStartEditKeyParams>
 */
export function apiKeysStartEditKey(params: apiKeysStartEditKeyParams): LogObject<apiKeysStartEditKeyParams> {
  return { evid: 209, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysFinishEditKey' event (evid: 210)
 *
 * Event description: The event is sent when a key is finished the editing process, regardless it was a success or not
 *
 * @param {apiKeysFinishEditKeyParams} params - The parameters for this event
 * @property {number} time_to_edit - The time it took to edit the key in ms (from evid 209 start edit key)
 * @property {string} failure_reason - The reason for the failure, can be empty
 * @property {string} old_key_permissions - The old permissions for the key
 * @property {string} new_key_name - The new api key name
 * @property {string} change_taken - The type of change taken - name\permisions\null
 * @property {string} key_id - The current app ID
 * @property {string} old_key_name - The old api name
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} new_key_permissions - The new permissions for the key
 * @property {boolean} was_success - True if the key was edited successfully
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysFinishEditKeyParams>} LogObject<apiKeysFinishEditKeyParams>
 */
export function apiKeysFinishEditKey(params: apiKeysFinishEditKeyParams): LogObject<apiKeysFinishEditKeyParams> {
  return { evid: 210, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysStartDuplicateKey' event (evid: 211)
 *
 * Event description: The event is sent when the user clicks on verify & save changes, to start duplicating a key
 *
 * @param {apiKeysStartDuplicateKeyParams} params - The parameters for this event
 * @property {string} duplicated_key_permissions - The permissions of the key that was duplicated
 * @property {string} change_taken - The type of change taken - name\permisions\null
 * @property {string} duplicated_key_id - The id of the key that was duplicated
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} duplicated_key_name - The name of the key that was duplicated
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysStartDuplicateKeyParams>} LogObject<apiKeysStartDuplicateKeyParams>
 */
export function apiKeysStartDuplicateKey(params: apiKeysStartDuplicateKeyParams): LogObject<apiKeysStartDuplicateKeyParams> {
  return { evid: 211, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysFinishDuplicateKey' event (evid: 212)
 *
 * Event description: The event is sent when a key is finished the duplicating process, regardless it was a success or not
 *
 * @param {apiKeysFinishDuplicateKeyParams} params - The parameters for this event
 * @property {string} failure_reason - The reason for the failure, can be empty
 * @property {string} app_def_id - the app_def_id of the key
 * @property {string} duplicated_key_permissions - The permissions of the key that was duplicated
 * @property {string} change_taken - The type of change taken - name\permisions\null
 * @property {string} duplicated_key_id - The id of the key that was duplicated
 * @property {number} time_to_duplicate - The time it took to duplicate the key in ms (from evid 2011 start duplicate key)
 * @property {string} key_id - The current api key ID
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} duplicated_key_name - The name of the key that was duplicated
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {boolean} was_success - True if the key was duplicated successfully
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysFinishDuplicateKeyParams>} LogObject<apiKeysFinishDuplicateKeyParams>
 */
export function apiKeysFinishDuplicateKey(params: apiKeysFinishDuplicateKeyParams): LogObject<apiKeysFinishDuplicateKeyParams> {
  return { evid: 212, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysStartRotateKey' event (evid: 213)
 *
 * Event description: The event is sent when the user clicks on validate & rotate key, to start rotate a key
 *
 * @param {apiKeysStartRotateKeyParams} params - The parameters for this event
 * @property {string} key_id - The current api ID
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysStartRotateKeyParams>} LogObject<apiKeysStartRotateKeyParams>
 */
export function apiKeysStartRotateKey(params: apiKeysStartRotateKeyParams): LogObject<apiKeysStartRotateKeyParams> {
  return { evid: 213, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysFinishRotateKey' event (evid: 214)
 *
 * Event description: The event is sent when a key is finished the rotate process, regardless it was a success or not
 *
 * @param {apiKeysFinishRotateKeyParams} params - The parameters for this event
 * @property {string} failure_reason - The reason for the failure, can be empty
 * @property {number} time_to_rotate - The time it took to rotate the key in ms (from evid 2013 start rotate key)
 * @property {string} key_id - The current api ID
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {boolean} was_success - True if the key was rotated successfully
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysFinishRotateKeyParams>} LogObject<apiKeysFinishRotateKeyParams>
 */
export function apiKeysFinishRotateKey(params: apiKeysFinishRotateKeyParams): LogObject<apiKeysFinishRotateKeyParams> {
  return { evid: 214, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysStartDeleteKey' event (evid: 215)
 *
 * Event description: The event is sent when the user clicks on verify & delete key, to start delete a key
 *
 * @param {apiKeysStartDeleteKeyParams} params - The parameters for this event
 * @property {string} key_id - The current api ID
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysStartDeleteKeyParams>} LogObject<apiKeysStartDeleteKeyParams>
 */
export function apiKeysStartDeleteKey(params: apiKeysStartDeleteKeyParams): LogObject<apiKeysStartDeleteKeyParams> {
  return { evid: 215, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysFinishDeleteKey' event (evid: 216)
 *
 * Event description: The event is sent when a key is finished the delete process, regardless it was a success or not
 *
 * @param {apiKeysFinishDeleteKeyParams} params - The parameters for this event
 * @property {string} failure_reason - The reason for the failure, can be empty
 * @property {number} time_to_delete - The time it took to delete the key in ms (from evid 2015 start delete key)
 * @property {string} key_id - The current api ID
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {boolean} was_success - True if the key was deleted successfully
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysFinishDeleteKeyParams>} LogObject<apiKeysFinishDeleteKeyParams>
 */
export function apiKeysFinishDeleteKey(params: apiKeysFinishDeleteKeyParams): LogObject<apiKeysFinishDeleteKeyParams> {
  return { evid: 216, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysClickOnSendCode' event (evid: 217)
 *
 * Event description: The event is sent when the user clicks on send code button, for the next actions - generate \ edit \ duplicate \ rotate \ delete
 *
 * @param {apiKeysClickOnSendCodeParams} params - The parameters for this event
 * @property {number} request_number - Running number of the send code request, for this api key
 * @property {string} key_id - The current api ID, will be null if it is duplicate \ generate action
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {string} request_id - The unique request id, same as the request id for identity and email marketing
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {string} action - The action the user is doing - generate \ edit \ duplicate \ rotate \ delete
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysClickOnSendCodeParams>} LogObject<apiKeysClickOnSendCodeParams>
 */
export function apiKeysClickOnSendCode(params: apiKeysClickOnSendCodeParams): LogObject<apiKeysClickOnSendCodeParams> {
  return { evid: 217, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysClickOnSendCodeAgain' event (evid: 218)
 *
 * Event description: The event is sent when the user clicks on send code again button, for the next actions - generate \ edit \ duplicate \ rotate \ delete
 *
 * @param {apiKeysClickOnSendCodeAgainParams} params - The parameters for this event
 * @property {string} key_id - The current api ID, will be null if it is duplicate \ generate action
 * @property {boolean} is_wix_employee - True if the user is wix employee
 * @property {number} num_of_keys - The number of keys in the account
 * @property {string} key_permissions - The chosen permissions for the key
 * @property {boolean} is_premium - True if the user has at least 1 premium package
 * @property {string} key_name - The current api name
 * @property {string} action - The action the user is doing - generate \ edit \ duplicate \ rotate \ delete
 * @property {number} number_sites - The number of sites in the account
 * @return {LogObject<apiKeysClickOnSendCodeAgainParams>} LogObject<apiKeysClickOnSendCodeAgainParams>
 */
export function apiKeysClickOnSendCodeAgain(params: apiKeysClickOnSendCodeAgainParams): LogObject<apiKeysClickOnSendCodeAgainParams> {
  return { evid: 218, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiKeysClickOnOauthPageLink' event (evid: 227)
 *
 * Event description: The event is sent when the user clicks on OAuth page link
 *
 * @param {apiKeysClickOnOauthPageLinkParams} params - The parameters for this event
 * @property {number} num_of_keys - The number of keys in the account
 * @return {LogObject<apiKeysClickOnOauthPageLinkParams>} LogObject<apiKeysClickOnOauthPageLinkParams>
 */
export function apiKeysClickOnOauthPageLink(params: apiKeysClickOnOauthPageLinkParams): LogObject<apiKeysClickOnOauthPageLinkParams> {
  return { evid: 227, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'triggerValueWasSelected' event (evid: 400)
 *
 * Event description: The event will be sent any time the user selects a trigger value in zapier creation flow
 *
 * @param {triggerValueWasSelectedParams} params - The parameters for this event
 * @property {string} triggerValues - A json of the trigger that was selected earlier
 * @property {boolean} isAppInstall - True if the app install at the site
 * @property {string} appName - The name of the app that was chosen (for example - booking)
 * @property {GUID} uuid - The uuid that made the action
 * @property {string} fieldLabel - The lable of the field that the user changed
 * @property {string} fieldValue - The value of the field that the user selected
 * @property {string} groupName - The name of the group that was chosen (for example - sub category of booking)
 * @property {string} appId - The guid of the app that was chosen (for example - booking guid)
 * @property {GUID} msid - The guid of the site
 * @return {LogObject<triggerValueWasSelectedParams>} LogObject<triggerValueWasSelectedParams>
 */
export function triggerValueWasSelected(params: triggerValueWasSelectedParams): LogObject<triggerValueWasSelectedParams> {
  return { evid: 400, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'zapierTestDataClick' event (evid: 401)
 *
 * Event description: The event will be sent any time the user test a zap in zapier
 *
 * @param {zapierTestDataClickParams} params - The parameters for this event
 * @property {string} triggerValues - A json of the trigger that was selected earlier
 * @property {boolean} isAppInstall - True if the app install at the site
 * @property {string} appName - The name of the app that was chosen (for example - booking)
 * @property {GUID} uuid - The uuid that made the action
 * @property {string} groupName - The name of the group that was chosen (for example - sub category of booking)
 * @property {string} appId - The guid of the app that was chosen (for example - booking guid)
 * @property {GUID} msid - The guid of the site
 * @return {LogObject<zapierTestDataClickParams>} LogObject<zapierTestDataClickParams>
 */
export function zapierTestDataClick(params: zapierTestDataClickParams): LogObject<zapierTestDataClickParams> {
  return { evid: 401, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'zapierCustomZapCreatedOrDeleted' event (evid: 402)
 *
 * Event description: the event will be sent when a custom zap was created or deleted from the zapier website.
 *
 * @param {zapierCustomZapCreatedOrDeletedParams} params - The parameters for this event
 * @property {string} ruleId - The rule id
 * @property {string} zapId - The zap id
 * @property {string} action - Detele / Cerate
 * @return {LogObject<zapierCustomZapCreatedOrDeletedParams>} LogObject<zapierCustomZapCreatedOrDeletedParams>
 */
export function zapierCustomZapCreatedOrDeleted(params: zapierCustomZapCreatedOrDeletedParams): LogObject<zapierCustomZapCreatedOrDeletedParams> {
  return { evid: 402, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessMigrationTourModalShown' event (evid: 8)
 *
 * Event description: The event will be sent each time the migration-tour-modal will be shown - so we will not show it twice per user (using active group)
 *
 * @param {headlessMigrationTourModalShownParams} params - The parameters for this event
 * @return {LogObject<headlessMigrationTourModalShownParams>} LogObject<headlessMigrationTourModalShownParams>
 */
export function headlessMigrationTourModalShown(params: headlessMigrationTourModalShownParams): LogObject<headlessMigrationTourModalShownParams> {
  return { evid: 8, src: 154, endpoint: '', params };
}

/**
 * A function to create a log object for the 'webhooksDispatcherResponseChannelTopicSrc155Evid3' event (evid: 3)
 *
 * Event description: Webhooks dispatcher response channel topic
 *
 * @param {webhooksDispatcherResponseChannelTopicSrc155Evid3Params} params - The parameters for this event
 * @property {string} topic - The webhook topic
 * @property {string} callbackUrl - The callback Url
 * @property {GUID} appDefId - the app def id made the call
 * @property {DateTime} kafkaTime - timestamp of the original kafka message
 * @property {number} retryNumber - retry attempt (the first one should be 0)
 * @property {string} statusCode - responded tatus code
 * @property {number} responseTime - time to response in ms
 * @property {DateTime} webhookTime - timestamp of firing the webhook
 * @property {string} originalTimestamp - The originalTimestamp
 * @property {string} retryAttempt - retryAttempt
 * @property {string} responseDuration - responseDuration
 * @return {LogObject<webhooksDispatcherResponseChannelTopicSrc155Evid3Params>} LogObject<webhooksDispatcherResponseChannelTopicSrc155Evid3Params>
 */
export function webhooksDispatcherResponseChannelTopicSrc155Evid3(params: webhooksDispatcherResponseChannelTopicSrc155Evid3Params): LogObject<webhooksDispatcherResponseChannelTopicSrc155Evid3Params> {
  return { evid: 3, src: 155, endpoint: '', params };
}

/**
 * A function to create a log object for the 'graphqlCall' event (evid: 400)
 *
 * Event description: The event will be sent when there is a GraphQL call
 *
 * @param {graphqlCallParams} params - The parameters for this event
 * @property {string} client_artifact_id - The artifact that was making the call
 * @property {string} operation_type - query / mutation
 * @property {GUID} metasiteId - msid of the site
 * @property {string} entity_call_breakdown - {   "fqdn1": {      "method1": ["field_1", "field_2"]      "method2": ["field_3", "field_4"] ... }
 * @property {string} source_type - headless/ TPA/ Internal site / Internal App
 * @property {GUID} appDefId - the app guid
 * @property {string} schema_name - The schema name - Internal / external / demo
 * @property {string} origin_url - The source url
 * @property {number} time_to_resolve - The time it takes to the resolver to obtain answer, in ms
 * @property {boolean} is_success - True if the call succeeded
 * @return {LogObject<graphqlCallParams>} LogObject<graphqlCallParams>
 */
export function graphqlCall(params: graphqlCallParams): LogObject<graphqlCallParams> {
  return { evid: 400, src: 155, endpoint: '', params };
}

/**
 * A function to create a log object for the 'autoVeloSiteCallForAMethod' event (evid: 401)
 *
 * Event description: The event is sent when the server gets a call for a method, from a site
 *
 * @param {autoVeloSiteCallForAMethodParams} params - The parameters for this event
 * @property {string} http_code - The http code for this call - 200\404\..
 * @property {string} api_owner - The API owner (company)
 * @property {string} failure_reason - The reason for the failure, can be empty
 * @property {string} service_name - The name of the service of the method
 * @property {string} entity_name - The FQDN of the entity
 * @property {string} environment - The type of development - front-end \ back-end
 * @property {string} module_name - The module name of the entity - edm name
 * @property {string} method_name - The name of the method that was in use
 * @property {string} msid - The msid of the site that made the call
 * @return {LogObject<autoVeloSiteCallForAMethodParams>} LogObject<autoVeloSiteCallForAMethodParams>
 */
export function autoVeloSiteCallForAMethod(params: autoVeloSiteCallForAMethodParams): LogObject<autoVeloSiteCallForAMethodParams> {
  return { evid: 401, src: 155, endpoint: '', params };
}

/**
 * A function to create a log object for the 'appsSettingsDeletionCandidate' event (evid: 700)
 *
 * Event description: Apps Settings - Deletion Candidate.
 *
 * @param {appsSettingsDeletionCandidateParams} params - The parameters for this event
 * @property {GUID} instance - .
 * @property {GUID} external_id - .
 * @property {GUID} app_id - .
 * @return {LogObject<appsSettingsDeletionCandidateParams>} LogObject<appsSettingsDeletionCandidateParams>
 */
export function appsSettingsDeletionCandidate(params: appsSettingsDeletionCandidateParams): LogObject<appsSettingsDeletionCandidateParams> {
  return { evid: 700, src: 155, endpoint: '', params };
}

/**
 * A function to create a log object for the 'settingsAccess' event (evid: 800)
 *
 * Event description: Settings Access.
 *
 * @param {settingsAccessParams} params - The parameters for this event
 * @property {GUID} instance - .
 * @property {GUID} external_id - .
 * @property {GUID} app_id - .
 * @return {LogObject<settingsAccessParams>} LogObject<settingsAccessParams>
 */
export function settingsAccess(params: settingsAccessParams): LogObject<settingsAccessParams> {
  return { evid: 800, src: 155, endpoint: '', params };
}

/**
 * A function to create a log object for the 'apiBlockGaRule' event (evid: 801)
 *
 * Event description: The event will be sent when an API is blocked GA rule/passed it - the API is blocked due to not following the rule condition
 *
 * @param {apiBlockGaRuleParams} params - The parameters for this event
 * @property {string} fqdn - The fqdn that was blocked
 * @property {boolean} isBlocked - True if the API was blocked
 * @property {string} method - The API method (function)
 * @property {string} namespace - The namespace of the method
 * @property {string} blockReason - If the API was blocked - the block reason
 * @property {string} serviceArtifactId - the service artifact id
 * @return {LogObject<apiBlockGaRuleParams>} LogObject<apiBlockGaRuleParams>
 */
export function apiBlockGaRule(params: apiBlockGaRuleParams): LogObject<apiBlockGaRuleParams> {
  return { evid: 801, src: 155, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessAddWixToYourProjectDialogIsShown' event (evid: 13)
 *
 * Event description: reported when user clicks to open ‘Add Wix to your Project’ dialog from Vercel/Netlify
 *
 * @param {headlessAddWixToYourProjectDialogIsShownParams} params - The parameters for this event
 * @property {string} provider - Netlify/Vercel
 * @property {string} business_type - The Business type that was chosen, relevant only for Netlify
 * @property {string} template_id - The template ID that was chosen, relevant only for Netlify
 * @return {LogObject<headlessAddWixToYourProjectDialogIsShownParams>} LogObject<headlessAddWixToYourProjectDialogIsShownParams>
 */
export function headlessAddWixToYourProjectDialogIsShown(params: headlessAddWixToYourProjectDialogIsShownParams): LogObject<headlessAddWixToYourProjectDialogIsShownParams> {
  return { evid: 13, src: 160, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessOAuthInstalled' event (evid: 15)
 *
 * Event description: reported when the user approve the app market dialog and an OAuth installed and redirect to Netlify/Vercel - the funnel was finished successfuly
 *
 * @param {headlessOAuthInstalledParams} params - The parameters for this event
 * @property {string} source - New to Wix / Existing Wix Business
 * @property {string} provider - Netlify/Vercel
 * @property {string} business_type - The Business type that was chosen, relevant only for Netlify
 * @property {string} template_id - The template ID that was chosen, relevant only for Netlify
 * @return {LogObject<headlessOAuthInstalledParams>} LogObject<headlessOAuthInstalledParams>
 */
export function headlessOAuthInstalled(params: headlessOAuthInstalledParams): LogObject<headlessOAuthInstalledParams> {
  return { evid: 15, src: 160, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessAddWixToYourProjectDialogClick' event (evid: 16)
 *
 * Event description: reported when user clicks on any button at the ‘Add Wix to your Project’ dialog from Vercel/Netlify
 *
 * @param {headlessAddWixToYourProjectDialogClickParams} params - The parameters for this event
 * @property {string} provider - Netlify/Vercel
 * @property {GUID} uuid - The uuid of the user
 * @property {GUID} client_id - client_id
 * @property {string} cta - Sign Up / Login / watch video
 * @property {string} business_type - The Business type that was chosen, relevant only for Netlify
 * @property {string} template_id - The template ID that was chosen, relevant only for Netlify
 * @return {LogObject<headlessAddWixToYourProjectDialogClickParams>} LogObject<headlessAddWixToYourProjectDialogClickParams>
 */
export function headlessAddWixToYourProjectDialogClick(params: headlessAddWixToYourProjectDialogClickParams): LogObject<headlessAddWixToYourProjectDialogClickParams> {
  return { evid: 16, src: 160, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessDeployThisTemplatePageIsShown' event (evid: 17)
 *
 * Event description: reported when the deploy this template page is shown
 *
 * @param {headlessDeployThisTemplatePageIsShownParams} params - The parameters for this event
 * @property {string} business_type - The Business type that was chosen, relevant only for Netlify
 * @property {string} template_id - The template ID that was chosen, relevant only for Netlify
 * @return {LogObject<headlessDeployThisTemplatePageIsShownParams>} LogObject<headlessDeployThisTemplatePageIsShownParams>
 */
export function headlessDeployThisTemplatePageIsShown(params: headlessDeployThisTemplatePageIsShownParams): LogObject<headlessDeployThisTemplatePageIsShownParams> {
  return { evid: 17, src: 160, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessDeployThisTemplatePageClick' event (evid: 18)
 *
 * Event description: reported when the user clicks on any cta at the deploy this template page
 *
 * @param {headlessDeployThisTemplatePageClickParams} params - The parameters for this event
 * @property {string} provider - Netlify / Vercel, will be sent only when the cta is continue
 * @property {string} cta - Deploy to Netlify / Deploy to Vercel / Continue / View Template Repo
 * @property {string} business_type - The Business type that was chosen, relevant only for Netlify
 * @property {string} template_id - The template ID that was chosen, relevant only for Netlify
 * @return {LogObject<headlessDeployThisTemplatePageClickParams>} LogObject<headlessDeployThisTemplatePageClickParams>
 */
export function headlessDeployThisTemplatePageClick(params: headlessDeployThisTemplatePageClickParams): LogObject<headlessDeployThisTemplatePageClickParams> {
  return { evid: 18, src: 160, endpoint: '', params };
}

/**
 * A function to create a log object for the 'headlessResumeSetUpDialogIsShown' event (evid: 19)
 *
 * Event description: reported when user clicks to open ‘Resume Set Up dialog from Vercel/Netlify
 *
 * @param {headlessResumeSetUpDialogIsShownParams} params - The parameters for this event
 * @property {string} provider - Netlify/Vercel
 * @property {string} business_type - The Business type that was chosen, relevant only for Netlify
 * @property {string} template_id - The template ID that was chosen, relevant only for Netlify
 * @return {LogObject<headlessResumeSetUpDialogIsShownParams>} LogObject<headlessResumeSetUpDialogIsShownParams>
 */
export function headlessResumeSetUpDialogIsShown(params: headlessResumeSetUpDialogIsShownParams): LogObject<headlessResumeSetUpDialogIsShownParams> {
  return { evid: 19, src: 160, endpoint: '', params };
}

/**
 * A function to create a log object for the 'copyOfHeadlessResumeSetUpDialogClick' event (evid: 20)
 *
 * Event description: reported when user clicks on any button at the ‘Resume Set Up’ dialog from Vercel/Netlify
 *
 * @param {copyOfHeadlessResumeSetUpDialogClickParams} params - The parameters for this event
 * @property {string} provider - Netlify/Vercel
 * @property {string} cta - Resume / Cancle
 * @property {string} business_type - The Business type that was chosen, relevant only for Netlify
 * @property {string} template_id - The template ID that was chosen, relevant only for Netlify
 * @return {LogObject<copyOfHeadlessResumeSetUpDialogClickParams>} LogObject<copyOfHeadlessResumeSetUpDialogClickParams>
 */
export function copyOfHeadlessResumeSetUpDialogClick(params: copyOfHeadlessResumeSetUpDialogClickParams): LogObject<copyOfHeadlessResumeSetUpDialogClickParams> {
  return { evid: 20, src: 160, endpoint: '', params };
}

/**
 * A function to create a log object for the 'testSrc184Evid9999' event (evid: 9999)
 *
 * Event description: test
 *
 * @param {testSrc184Evid9999Params} params - The parameters for this event
 * @return {LogObject<testSrc184Evid9999Params>} LogObject<testSrc184Evid9999Params>
 */
export function testSrc184Evid9999(params: testSrc184Evid9999Params): LogObject<testSrc184Evid9999Params> {
  return { evid: 9999, src: 184, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixMcpRequestSrc39Evid1607' event (evid: 1607)
 *
 * Event description: Fires when a user runs a query through the Wix MCP, capturing activity at the tool execution level.
 *
 *
 *
 * @param {wixMcpRequestSrc39Evid1607Params} params - The parameters for this event
 * @property {string} sessionId - the relevant session_id (multiple questions in a session)
 * @property {string} queryId - the request id (per user question - many to one with session)
 * @property {string} toolInvocationId - the tool execution id (per tool execution - many to one with user question)
 *
 * @property {string} query - the actual user query string being passed (prompt)
 * @property {string} toolName - The name of the MCP tool that was triggered
 * @property {string} params - the params sent in the tool invocation
 * @property {string} origin - relevant source/agent calling the MCP server (remote/local/picasso)
 * @property {number} duration - duration time per execution (ms)
 * @property {string} executionResult - Success/Error (defined by the tool)
 * @property {string} errorBody - for cases where the execution result was an error
 * @return {LogObject<wixMcpRequestSrc39Evid1607Params>} LogObject<wixMcpRequestSrc39Evid1607Params>
 */
export function wixMcpRequestSrc39Evid1607(params: wixMcpRequestSrc39Evid1607Params): LogObject<wixMcpRequestSrc39Evid1607Params> {
  return { evid: 1607, src: 39, endpoint: '', params };
}

/**
 * A function to create a log object for the 'webhooksInDcCodeExampleWindowClicks' event (evid: 11905)
 *
 * Event description: The event will be sent on any click at the code example window at the webhooks page in DC 
 *
 * @param {webhooksInDcCodeExampleWindowClicksParams} params - The parameters for this event
 * @property {string} codeType - node.sj / etc... - what was chosen when the user clicked on the cta
 * @property {string} webhookApiCategory - The API category that the user is currently works on
 * @property {string} webhookEventType - The event type that the user is currently works on
 * @property {string} webhookSlug - The webhook_slug that the user is currently works on
 * @property {string} cta - The click name that the user clicked on (X, node.js, copy, etc))
 * @property {string} displayType - side bar / modal
 * @property {string} extra_values - Any extra value. for example - when the user chose a different lang, it will sent the lan that was choosen. can be null.
 * @return {LogObject<webhooksInDcCodeExampleWindowClicksParams>} LogObject<webhooksInDcCodeExampleWindowClicksParams>
 */
export function webhooksInDcCodeExampleWindowClicks(params: webhooksInDcCodeExampleWindowClicksParams): LogObject<webhooksInDcCodeExampleWindowClicksParams> {
  return { evid: 11905, src: 96, endpoint: '', params };
}

/**
 * A function to create a log object for the 'webhooksInDcTriggeredTestModalClicks' event (evid: 11906)
 *
 * Event description: The event will be sent on any click at the triggered test modal at the webhooks page in DC 
 *
 * @param {webhooksInDcTriggeredTestModalClicksParams} params - The parameters for this event
 * @property {string} cta - The click name that the user clicked on (copy / close / X)
 * @property {string} webhookApiCategory - The API category that the user is currently works on
 * @property {string} webhookEventType - The event type that the user is currently works on
 * @property {string} webhookSlug - The webhook_slug that the user is currently works on
 * @return {LogObject<webhooksInDcTriggeredTestModalClicksParams>} LogObject<webhooksInDcTriggeredTestModalClicksParams>
 */
export function webhooksInDcTriggeredTestModalClicks(params: webhooksInDcTriggeredTestModalClicksParams): LogObject<webhooksInDcTriggeredTestModalClicksParams> {
  return { evid: 11906, src: 96, endpoint: '', params };
}

/**
 * A function to create a log object for the 'webhooksInDcCodeExampleWindowScroll' event (evid: 11907)
 *
 * Event description: The event will be sent a scroll at the code example window at the webhooks page in DC 
 *
 * @param {webhooksInDcCodeExampleWindowScrollParams} params - The parameters for this event
 * @property {string} codeType - node.sj / etc... - what was chosen when the user clicked on the cta
 * @property {string} webhookApiCategory - The API category that the user is currently works on
 * @property {string} webhookEventType - The event type that the user is currently works on
 * @property {string} webhookSlug - The webhook_slug that the user is currently works on
 * @property {string} scrollType - vertical/horizontal
 * @property {string} displayType - side bar / modal
 * @return {LogObject<webhooksInDcCodeExampleWindowScrollParams>} LogObject<webhooksInDcCodeExampleWindowScrollParams>
 */
export function webhooksInDcCodeExampleWindowScroll(params: webhooksInDcCodeExampleWindowScrollParams): LogObject<webhooksInDcCodeExampleWindowScrollParams> {
  return { evid: 11907, src: 96, endpoint: '', params };
}

/**
 * A function to create a log object for the 'webhooksInDcCreateEventPageClicks' event (evid: 11908)
 *
 * Event description: The event will be sent on any click at the create event page at the webhooks page in DC 
 *
 * @param {webhooksInDcCreateEventPageClicksParams} params - The parameters for this event
 * @property {string} webhookApiCategory - The API category that the user is currently works on
 * @property {string} webhookEventType - The event type that the user is currently works on
 * @property {string} webhookSlug - The webhook_slug that the user is currently works on
 * @property {string} cta - The click name that the user clicked on (code sample / trigger test / view guide / api reference)
 * @return {LogObject<webhooksInDcCreateEventPageClicksParams>} LogObject<webhooksInDcCreateEventPageClicksParams>
 */
export function webhooksInDcCreateEventPageClicks(params: webhooksInDcCreateEventPageClicksParams): LogObject<webhooksInDcCreateEventPageClicksParams> {
  return { evid: 11908, src: 96, endpoint: '', params };
}

/**
 * A function to create a log object for the 'webhooksInDcMainPageClicks' event (evid: 12301)
 *
 * Event description: The event will be sent on any click at the webhooks main page in DC 
 *
 * @param {webhooksInDcMainPageClicksParams} params - The parameters for this event
 * @property {string} webhookApiCategory - The API category that the user is currently works on
 * @property {string} webhookEventType - The event type that the user is currently works on
 * @property {string} clickType - Navigation, action, expend, colapsed
 * @property {string} location - popover, top, bottom, table
 * @property {string} clickName - the name of the button that was clicked
 * @property {string} pageViewType - webhook list / webhook log
 * @return {LogObject<webhooksInDcMainPageClicksParams>} LogObject<webhooksInDcMainPageClicksParams>
 */
export function webhooksInDcMainPageClicks(params: webhooksInDcMainPageClicksParams): LogObject<webhooksInDcMainPageClicksParams> {
  return { evid: 12301, src: 96, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devCenterWebhookSentTriggered' event (evid: 1300)
 *
 * Event description: Dev Center - Webhook - Sent / Triggered
 *
 * @param {devCenterWebhookSentTriggeredParams} params - The parameters for this event
 * @property {GUID} instanceId - guid
 * @property {GUID} webhookId - guid
 * @property {string} url - url
 * @property {string} httpMethod - http method
 * @property {string} webhookEventType - webhook_event_type
 * @property {string} responseStatus - response_status
 * @property {string} topic - topic
 * @property {GUID} appId - app id
 * @property {string} originalTimestamp - originalTimestamp
 * @property {string} retryAttempt - retryAttempt
 * @property {string} statusCode - statusCode
 * @property {string} responseDuration - responseDuration
 * @property {string} kafkaEventId - unique identifier for each kafka attempt
 * @property {string} KafkaWebhookId - unique id to each webhook call (if there are 2 attempts - 2 row with this id)
 * @property {string} startHandlingTimestamp - start_handling_timestamp. when the webhook dispatcher started to work on the message
 * @return {LogObject<devCenterWebhookSentTriggeredParams>} LogObject<devCenterWebhookSentTriggeredParams>
 */
export function devCenterWebhookSentTriggered(params: devCenterWebhookSentTriggeredParams): LogObject<devCenterWebhookSentTriggeredParams> {
  return { evid: 1300, src: 96, endpoint: '', params };
}

/**
 * A function to create a log object for the 'spiExternalInvocationSrc96Evid199' event (evid: 199)
 *
 * Event description: SPI external invocation - REST call only - TPAs.
 *
 * @param {spiExternalInvocationSrc96Evid199Params} params - The parameters for this event
 * @property {string} appId - The app id used the spi
 * @property {string} msid - The msid used the spi
 * @property {string} componentId - per unique app & component (there can be 2 same spis to the same app)
 * @property {string} componentType - spi identifier
 * @property {string} statusCode - the status_code of the invocation
 * @property {string} instanceId - The instance (msid+app_id) that trigger the spi
 * @property {string} responseDuration - in ms
 * @property {string} functionName - the action that the spi does
 * @property {string} appDefId - The app def id
 * @return {LogObject<spiExternalInvocationSrc96Evid199Params>} LogObject<spiExternalInvocationSrc96Evid199Params>
 */
export function spiExternalInvocationSrc96Evid199(params: spiExternalInvocationSrc96Evid199Params): LogObject<spiExternalInvocationSrc96Evid199Params> {
  return { evid: 199, src: 96, endpoint: '', params };
}
